// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:triple-equals
import { Component, OnInit, TemplateRef, ViewChild, ChangeDetectorRef, HostListener, ElementRef, ViewChildren, QueryList, Input, Renderer2, OnDestroy } from '@angular/core';
import { MainService } from 'src/app/services/main-service.service';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { ProposalService } from 'src/app/services/proposal/proposal.service';
import { DatePipe } from '@angular/common';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { WriteToUsComponent } from '../../write-to-us/write-to-us.component';
import { CallbackComponent } from '../../callback/callback.component';
import { Subject, zip } from 'rxjs';
// import { plaidService } from 'src/app/services/plaid.service';
// import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from '@angular/material/core';
import { environment } from 'src/environments/environment';
import { CustomDateAdapter } from 'src/app/shared/date-time/date-adapter.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { SignaturePadComponent } from 'src/app/shared/signature-pad/signature-pad.component';
import { ScreenshotService } from 'src/app/services/screen-shot.service';
import * as moment from "moment-timezone";
import { take } from 'rxjs/operators';
// import { SignaturePadComponent } from 'src/app/shared/signature-pad/signature-pad.component';

// export const MY_FORMATS = {
//   parse: {
//     dateInput: 'MM/DD/YYYY'
//   },
//   display: {
//     dateInput: 'MM/DD/YYYY',
//     monthYearLabel: "MMM YYYY",
//   }
// };

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    [
      CustomDateAdapter, // so we could inject services to 'CustomDateAdapter'
      { provide: DateAdapter, useClass: CustomDateAdapter }, // Parse MatDatePicker Format
    ],
  ]
})
export class PaymentDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  payment_step = 1;
  opened_step = 1;
  cardError: any;
  contractToken: any;
  selectedPlanIndex: any;
  bsConfig = {
    showWeekNumbers: false,
    containerClass: window.screen.width < 768 ? 'theme-mobile-blue' : 'theme-blue',
    dateInputFormat: 'MM/dd/yyyy',
    selectFromOtherMonth: true
  };
  // planInfo: any;
  // tslint:disable:no-inferrable-types
  add_button: boolean = false;
  planInfo: any = {
    recurring_amount: '',
    selected_plan: { month: '' },
    treatment_amount: 0,
  };
  validation_rules: any;
  modalRef: BsModalRef;
  terms: any;
  signed: any;
  add_bank_step = 'card';
  selected_card: any = '';
  contract_code: any = '';
  date: Date = new Date();
  payment_source_type = '';
  charge_flow = 1
  @ViewChild('dobdp') private _picker: BsDatepickerDirective;
  // @ViewChild(SignaturePad) signaturePad: SignaturePad;
  @ViewChild('screenManager') screenManager!: ElementRef<HTMLElement>;
  @ViewChild('screenshotRoot') screenshotRoot!: ElementRef<HTMLElement>;
  @ViewChild('canvasDiv') canvasDiv: ElementRef<any>;
  @ViewChild('canvasDiv1') canvasDiv1: ElementRef<any>;
  @ViewChild('successModal') successModal: TemplateRef<any>;
  @ViewChild('failModal') failModal: TemplateRef<any>;
  @ViewChild('secondaryCardModal') public secondaryCardModal: ModalDirective;
  @ViewChild('addNewPaymentMethodModal') public addNewPaymentMethodModal: ModalDirective;
  @ViewChild('paymentFail') public paymentFail: ModalDirective;
  @ViewChild('askRecurringCardModal') public askRecurringCardModal: ModalDirective;
  @ViewChild('addRecurringCardModal') public addRecurringCardModal: ModalDirective;
  @ViewChild('confirmPaymentModal') public confirmPaymentModal: ModalDirective;
  buttonClickedSubject: Subject<any> = new Subject();
  card_payment_tried = 0;
  paymentDetails: any = {
    cardName: '',
    stripeToken: '',
    recurringDate: ''
  };
  paymentLoader = false;
  patient_address: UntypedFormGroup = this.fb.group({});
  loadingZip = false;
  zips: any[] = [];
  closure_html: any;
  closure_terms: any;
  show_closure_form: any = 0;
  mask;
  @ViewChild('addBankModal') public addBankModal: ModalDirective;
  @ViewChild('addAddressModal') public addAddressModal: ModalDirective;
  @ViewChild('closureModal') public closureModal: ModalDirective;
  @ViewChild(SignaturePadComponent) signaturePadComponent!: SignaturePadComponent;

  dp_last4 = '';
  recurring_last4 = '';
  recurring_date = '';
  recurring_token = '';
  alternate_recurring_source_id = '';
  payble_text = '';
  payment_error = '';
  patientData: any = {
    primary_sources: [],
    recurring_sources: [],
    backup_sources: []
  };
  patientSsn: any;
  show_backup = false;
  dp_source_id = 0;
  recurring_source_id = 0;
  backup_source_id = 0;
  selected_dp_card;
  selected_recurring_card;
  selected_backup_card;
  is_waived = 0;
  new_bank_added = 0;
  actual_matrix;
  success_message = "Your payment has been made successfully!\nPlease click on continue to finish your application.";
  primary_card_added = 0;
  recurring_card_added = 0;
  backup_card_added = 0;
  add_card_source_id;
  cards_array = [];
  enrollmentfee: number;
  split_request_data: any;
  check_business_terms = false;
  signatureUrl: any;
  signature: any;
  public signaturePadOptions: Object = {
    'minWidth': 2,
    'canvasWidth': 575,
    'canvasHeight': 200
  };
  patient_zip: any = [];
  zipSelected = false;
  selectedZip: any;
  current_step = 2;
  financing_info: any = [];
  zipCode: any = '';
  zipPostalCode: any;
  add_added: boolean;
  contract_type: any;
  opened_modal: any;
  settingsData: any = {};
  greater: any;
  contract_service_record: any = [];
  allRecords: any;
  flag_code = '';
  showvalidation: boolean = false;
  showSSNfields: boolean = true;
  backUpCard: boolean = false;
  mobile_pattern: any;
  bank_addded = false;
  language_data: any;
  selectedLanguage: any;
  inside: boolean = false;
  showConfirmationDialog: boolean = false;
  stripeFieldsshow: boolean = false;
  valueNotValid: boolean = false;
  errorMsg = '';
  recurringCard: boolean = false;
  todayPaymentCard: boolean;
  dataEnter: boolean = false;
  validValue: boolean = false;
  patientData_recure: any;
  patientData_backup: any;
  buttonSelectedType = {
    existing: 1,
    bank: 2,
    cardTab: 3
  };
  selectTypeButtonCardBank = '';
  stepHeader: any;
  showGoogleApi = false;
  regexMode: any;
  mobile_validation: any;
  phone_length: any;
  min_phone_length: any;
  editAddressManually = false;
  customZip = true;
  country_states: any;
  showDropDown: boolean;
  creditReportOption = false;
  api_credit_report_status = 0;
  isSubmitted = false;
  timezone: any;
  constructor(
    private el: ElementRef,
    public mainService: MainService,
    public route: ActivatedRoute,
    public router: Router,
    public proposal: ProposalService,
    public datePipe: DatePipe,
    public toaster: ToasterService,
    private modalService: BsModalService,
    public cd: ChangeDetectorRef,
    // public plaidService: plaidService,
    public fb: UntypedFormBuilder,
    public render: Renderer2,
    public screenshotService: ScreenshotService
  ) {
    let xToken = this.route.snapshot.queryParams['x-token']
    if (!xToken) {
      let emailToken = JSON.parse(localStorage.getItem('x-token'))
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { 'x-token': emailToken },
        queryParamsHandling: 'merge',
      });
    }
  }

  ngOnInit() {
    this.render.addClass(document.body, 'payment-details');
    setTimeout(() => {
      this.showGoogleApi = true;
    }, 2000);
    this.mainService.topHeader.subscribe((data) => {
      this.stepHeader = data;
      console.log(this.stepHeader);
    });
    this.scrollToTop();
    this.detect();
    this.mainService.closePayBtn = true;
    this.patient_address = this.fb.group({
      patient_first_name: ['', Validators.required],
      patient_last_name: ['', Validators.required],
      // tslint:disable-next-line:max-line-length
      patient_email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      patient_mobile: ['', Validators.required],
      patient_ssn: ['', Validators.required],
      city: [{ value: '', disabled: false }, [Validators.required]],
      city_id: ['', Validators.required],
      // state: ['', Validators.required],
      state_name: [{ value: '', disabled: true }, [Validators.required]],
      state_code: ['', [Validators.required]],
      zip: [{ value: '' }, Validators.required],
      address: ['', Validators.required],
      address_2: [''],
      zipSelected: false,
      patient_mobile_country_code: [{ value: '', disabled: true }],
      language_preffered: ['', Validators.required]
    });
    this.payment_step = 1;
    // this.opened_step = 1;
    this.route.params.subscribe((data: any) => {
      this.contractToken = data.token;
      this.proposal.setToken(this.contractToken);
    });

    this.route.queryParams.subscribe((data: any) => {
      if (data.setup_intent || data.setup_intent_client_secret) {
        const params = {
          url: window.location.href
        };
        this.proposal.api('post', 'track_stripe_redirect', this.mainService.urlParams(params))
          .subscribe((d: any) => {
            console.log(d);
          });
        console.log(window.location.href);
      }
      this.selectedPlanIndex = data.plan || 0;
      this.creditReportOption = JSON.parse(data?.cr || 0) == 1 ? true : false
      if (data?.step == 2) {
        this.mainService.current_step = Number(data.step);
      }
    });

    this.mainService.subject
      .subscribe((data: any) => {
        this.ShowStripeElement();
      });
    if (this.mainService.data && this.mainService.data.is_error == 0) {
      this.ShowStripeElement();
    }
    this.mainService.language_data$.subscribe(data => {
      if (data && data.length) {
        this.language_data = data;
      }
    })
    this.mainService.regex$.subscribe(data => {
      if (data) {
        this.regexMode = data.DL;
        this.validation_rules = data;
        console.log(this.regexMode, data);
      }
    })

    this.proposal.getData().pipe(take(1)).subscribe(async (data: any) => {
      this.timezone = data?.timezone || data?.split_request_data?.[0]?.timezone || data?.result?.timezone || '+0000';
      this.showSSNfields = data.doctor_country_currency_info.SSN;
      this.mobile_pattern = data.doctor_country_currency_info.mobile_regex;
      this.phone_length = data.doctor_country_currency_info?.phone_length || 12;
      this.min_phone_length = data.doctor_country_currency_info?.min_phone_length || 7;
      this.updateMasking(data.doctor_country_currency_info['country']['country_phone_format']);
      this.contract_service_record = data.split_request_data;
      if (this.contract_service_record && this.contract_service_record.length) {
        this.patient_address.patchValue({ language_preffered: this.contract_service_record[0].language_preffered });
      }

      if (data.split_request_data && data.split_request_data.length && data.split_request_data[0] && data.split_request_data[0].plans_array) {
        data.split_request_data[0].plans_array = data.split_request_data[0].plans_array.sort((a, b) => {
          return a.month - b.month;
        });
      }
      // console.log('data.split_request_data', data.split_request_data);
      // tslint:disable-next-line:max-line-length
      this.allRecords = typeof this.contract_service_record[0].contract_service_record == 'string' ? JSON.parse(this.contract_service_record[0].contract_service_record) : this.contract_service_record[0].contract_service_record;
      // console.log(this.allRecords);

      this.contract_type = data.split_request_data[0].contract_type;
      if (data && data.patients && data.patients.length > 0) {
        this.patientData = data.patients[0];
        console.log(this.patientData, this.planInfo);
        // this.patientData['patient_ssn'] = '';
        this.patientSsn = this.patientData.hasOwnProperty("patient_ssn") ? (this.patientData['patient_ssn'] == null ? '' : this.patientData['patient_ssn']) : '';
        if (this.patientData && this.patientData['plaid_access_token'] && this.patientData['bank_status'] == 'pending') {
          if (!this.patientData['payment_sources']) {
            this.patientData['payment_sources'] = [];
          }
          const pending_banks = this.patientData['payment_sources'].filter(source => source.source_id == -1);
          if (pending_banks.length == 0) {
            // tslint:disable-next-line:max-line-length
            this.patientData['payment_sources'] = [...[{ payment_source_type: 1, last4: 'XXXX', source_id: -1 }], ...this.patientData['payment_sources']];
          }
        }
        if (this.patientData && this.patientData['payment_sources'] && this.patientData['payment_sources'].length > 0) {
          this.patientData['payment_sources'] = this.patientData['payment_sources'].sort(function (a, b) {
            return a.payment_source_type - b.payment_source_type;
          });
        }
        const bankList = this.patientData['payment_sources'].filter(item => item.payment_source_type == 1);
        if (bankList && bankList.length) {
          this.bank_addded = true;
        }
        this.checkNavigationData();
      }
      if (data && data.split_request_data && data.split_request_data.length) {
        this.split_request_data = data.split_request_data;
        await this.getStates();
      }
      if (data && data.financing_info && data.financing_info.length > 0) {
        this.financing_info = data.financing_info[0];
      }

      // tslint:disable-next-line:max-line-length
      if (this.split_request_data[0].is_ar_contract == 1 ? ((this.patientData['patient_first_name'] && this.patientData['patient_email']) || (this.split_request_data['patient_first_name'] && this.split_request_data['patient_email'])) : ((this.patientData && this.patientData['patient_first_name'] && this.patientData['patient_last_name'] && this.patientData['patient_address'] && this.patientData['patient_email']) || (this.split_request_data[0].patient_first_name && this.split_request_data[0].patient_last_name && this.split_request_data[0].patient_email))) {
        setTimeout(() => {
          this.patient_address.patchValue({
            patient_first_name: this.split_request_data[0].patient_first_name || this.patientData['patient_first_name'],
            patient_last_name: this.split_request_data[0].patient_last_name || this.patientData['patient_last_name'],
            patient_email: this.split_request_data[0].patient_email || this.patientData['patient_email'],
            // tslint:disable-next-line:max-line-length
            patient_mobile: (this.split_request_data[0].patient_mobile && this.split_request_data[0].apf_patient_mobile || this.planInfo.apf_patient_mobile) ? (this.split_request_data[0].apf_patient_mobile || this.planInfo.apf_patient_mobile) : this.planInfo.apf_patient_mobile || this.patientData['patient_mobile'],
            // tslint:disable-next-line:max-line-length
            patient_ssn: this.patientData['patient_ssn'] && this.patientData['patient_ssn'].length > 0 ? (new Array(this.patientData['patient_ssn'].length - 4).fill('*').join('') + (this.patientData['patient_ssn'] + '').substring(this.patientData['patient_ssn'].length - 4, this.patientData['patient_ssn'].length)) : '',
            city: '',
            city_id: '',
            state: '',
            state_name: '',
            zip: '',
            address: ((this.split_request_data[0].patient_address || this.patientData.patient_address || '').split(' || ')[0]),
            address_2: ((this.split_request_data[0].patient_address || this.patientData.patient_address || '').split(' || ')[1]),

            zipSelected: false,
            patient_mobile_country_code: this.split_request_data[0].patient_mobile_country_code || this.planInfo.patient_mobile_country_code || this.patientData['patient_mobile_country_code']
          });

          if (this.split_request_data && (this.split_request_data[0].country_id == 7)) {
            this.australiaChange(this.split_request_data[0].patient_mobile_country_code);
          }

          if (!this.patient_address.controls['patient_mobile_country_code'].value) {
            if (this.mainService.country_data && this.mainService.country_data.length) {
              // tslint:disable-next-line:no-string-literal
              this.patient_address.patchValue({ patient_mobile_country_code: this.mainService.country_data[0]['mobile_code'] });
              this.flag_code = (this.mainService.country_data[0]['country_code'] + '').toLocaleLowerCase();
            }
          } else {
            if (this.mainService.country_data && this.mainService.country_data.length) {
              this.flag_code = this.mainService.findFlagCode(this.patient_address.value['patient_mobile_country_code']);
            }
          }
          if (this.patientData['patient_email'] || this.split_request_data[0].patient_email || this.planInfo.apf_patient_email) {
            this.patient_address.controls.patient_email.disable();
            this.patient_address.updateValueAndValidity();
          }
          if (this.patientData['patient_ssn']) {
            this.patient_address.controls.patient_ssn.disable();
            this.patient_address.updateValueAndValidity();
          }
          let customerZip = {
            zip: '',
            city: '',
            city_id: '',
            state_name: '',
            state_code: '',
            formatted_address: '',
          };
          if (this.patientData['zip'] || this.planInfo['zip']) {
            customerZip = {
              zip: this.planInfo['zip'] || this.patientData['zip'],
              city: this.planInfo['city'] || this.patientData['city'],
              city_id: this.planInfo['city_id'] || this.patientData['city_id'],
              state_name: this.planInfo['state'] || this.patientData['state'],
              state_code:this.planInfo['state_code']|| this.patientData['state_code'],
              formatted_address: (this.planInfo['patient_address'] || this.patientData['patient_address']).includes("||") ? (this.planInfo['patient_address'] || this.patientData['patient_address']).split("||")[0]?.trim() : this.planInfo['patient_address'] || this.patientData['patient_address']
            };
          }
          this.getZipselected(customerZip);
        }, 200);
      } else {
        this.patient_address.patchValue({ patient_mobile_country_code: this.mainService.country_data[0]['mobile_code'] });
      }
      this.setData(data);
    });

    // this.plaidService.plaid_success_subject.subscribe((data: any) => {
    //   if (data == 1) {
    //     this.new_bank_added = 1;
    //   }
    // });
    this.new_bank_added = 0;
    this.mainService.getMsg().subscribe((data: any) => {
      this.settingsData = data;
      // Stripe.setPublishableKey(data.stripe_pk);
      // console.log(this.settingsData);
    });
    this.mainService.finance_error_from = 'proposal_link';
  }

  ngOnDestroy(): void {
    this.render.removeClass(document.body, 'payment-details');
  }
  updateMasking(format: any) {
    format = format ? format : "";
    this.mask = format.replace(/#/g, '0');
    // this.mask = '0000-000-000';
  }
  // ngAfterViewChecked() {
  //   this.scrollToTop();
  // }

  scrollToTop(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = 0;
    } catch (err) { }
  }


  checkNavigationData() {
    if (this.contractToken && localStorage.getItem('navigation_data')) {
      let data = JSON.parse(localStorage.getItem('navigation_data'))
      if (this.contractToken) {
        let navigation_data = data[this.contractToken];
        if (navigation_data) {
          if (navigation_data.payment_step) {
            this.payment_step = navigation_data.payment_step;
            this.opened_step = navigation_data.payment_step;
            if (this.payment_step == 3) {
              this.terms = true;
              this.signed = true;
            }
          }
          if (navigation_data.recurring_source_id) {
            this.recurring_source_id = navigation_data.recurring_source_id;
            let matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.recurring_source_id)
            if (matched_source && matched_source[0]) {
              this.selected_recurring_card = matched_source[0];
            } else {
              this.recurring_source_id = null;
              this.payment_step = 2;
              this.opened_step = 2;
            }
          } else {
            this.payment_step = 2;
            this.opened_step = 2;
          }
          if (navigation_data.dp_source_id) {
            this.dp_source_id = navigation_data.dp_source_id;
            let matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.dp_source_id);
            if (matched_source && matched_source[0]) {
              this.selected_dp_card = matched_source[0];
            } else {
              this.dp_source_id = null;
              this.payment_step = 1;
              // this.opened_step = 1;
            }
          } else {
            this.payment_step = 1;
            // this.opened_step = 1;
          }
          if (navigation_data.backup_source_id) {
            this.backup_source_id = navigation_data.backup_source_id;
            let matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.backup_source_id)
            if (matched_source && matched_source[0]) {
              this.selected_backup_card = matched_source[0];
            } else {
              this.backup_source_id = null;
            }
          }
        }
      }
    }
  }
  checkPaymentSources() {
    if (!this.patientData['payment_sources']) {
      this.patientData['payment_sources'] = [];
    }
    const data = JSON.parse(localStorage.getItem('navigation_data'));
    if (data && data[this.contractToken] && data[this.contractToken].opened_step) {
      this.opened_step = data[this.contractToken].opened_step
    }

    if (this.patientData['payment_sources'].length > 0) {
      if (this.new_bank_added == 1) {
        let banks = this.patientData['payment_sources'].filter(source => source.payment_source_type == 1);
        if (banks && banks[0]) {
          if (Number(data[this.contractToken].opened_step) === 1) {
            this.dp_source_id = banks[0].source_id;
            this.opened_step = data[this.contractToken].opened_step;
            this.primaryCardChanged(banks[0].payment_source_type, banks[0].source_id);
          } else if (Number(data[this.contractToken].opened_step) === 2) {
            this.recurring_source_id = banks[0].source_id;
            this.opened_step = data[this.contractToken].opened_step;
          } else if (this.payment_step == 3) {
            this.backup_source_id = banks[0].source_id;
            this.opened_step = data[this.contractToken].opened_step;
          }
          if (window.screen.width < 768) {
            if (Number(data[this.contractToken].opened_step) === 1) {
              this.opened_step = 1;
              this.payment_step = 2;
            } else if (Number(data[this.contractToken].opened_step) === 2) {
              this.opened_step = 2;
              this.payment_step = 3;
            } else if (Number(data[this.contractToken].opened_step) === 3) {
              this.opened_step = 3;
            }
            this.setNavigationData();
          }
        }
        this.new_bank_added = 0;
      }
      if (this.recurring_source_id == -1) {
        this.planInfo.selected_payment_matrix.backup_type = 2;
      }
      if (this.selected_recurring_card && this.selected_recurring_card.payment_source_type == 1) {
        this.planInfo.selected_payment_matrix.backup_type = 2;
      }

      if (this.selected_recurring_card && Number(this.selected_recurring_card.payment_source_type) !== 1) {
        this.planInfo.selected_payment_matrix.backup_type = this.split_request_data[0].payment_matrix_array[0].backup_type;
      }

      // if (this.dp_source_id == -1) {
      //   this.planInfo.selected_payment_matrix.recurring_type = 2;
      //   this.planInfo.selected_payment_matrix.backup_type = 2;
      //   if (this.recurring_source_id == -1) {
      //     this.recurring_source_id = null;
      //   }
      //   if (this.backup_source_id == -1) {
      //     this.backup_source_id = null;
      //   }
      // }
      // if (this.recurring_source_id == -1) {
      //   this.planInfo.selected_payment_matrix.backup_type = 2;
      //   if (this.backup_source_id == -1) {
      //     this.backup_source_id = null;
      //   }
      // }
      this.patientData['primary_sources'] = this.patientData['payment_sources'].filter(source => {
        // tslint:disable-next-line:max-line-length
        return this.planInfo.selected_payment_matrix.primary_type == 3 || (this.planInfo.selected_payment_matrix.primary_type == 1 && source.payment_source_type == 1) || (this.planInfo.selected_payment_matrix.primary_type == 2 && source.payment_source_type != 1)
      });
      this.patientData['recurring_sources'] = this.patientData['payment_sources'].filter(source => {
        // tslint:disable-next-line:max-line-length
        return ((this.planInfo.selected_payment_matrix.recurring_type == 3) || (this.planInfo.selected_payment_matrix.recurring_type == 1 && source.payment_source_type == 1) || (this.planInfo.selected_payment_matrix.recurring_type == 2 && source.payment_source_type != 1))
      });

      this.patientData['backup_sources'] = this.patientData['payment_sources'].filter(source => {
        // tslint:disable-next-line:max-line-length
        return (this.planInfo.selected_payment_matrix.backup_type == 3 || (this.planInfo.selected_payment_matrix.backup_type == 1 && source.payment_source_type == 1) || (this.planInfo.selected_payment_matrix.backup_type == 2 && source.payment_source_type != 1));
      });

    } else {
      this.patientData['primary_sources'] = [];
      this.patientData['recurring_sources'] = [];
      this.patientData['backup_sources'] = [];
    }
    const card_primary_sources = this.patientData['primary_sources'].filter(source => source.payment_source_type != 1);
    const card_recurring_sources = this.patientData['recurring_sources'].filter(source => source.payment_source_type != 1);
    const card_backup_sources = this.patientData['backup_sources'].filter(source => source.payment_source_type != 1);
    this.primary_card_added = card_primary_sources && card_primary_sources.length > 0 ? 1 : 0;
    this.recurring_card_added = card_recurring_sources && card_recurring_sources.length > 0 ? 1 : 0;
    this.backup_card_added = card_backup_sources && card_backup_sources.length > 0 ? 1 : 0;
    if (this.recurring_source_id == -1) {
      this.planInfo.selected_payment_matrix.backup_required = 1;
    }
    if (this.selected_dp_card == undefined) {
      if (this.dp_source_id) {
        const matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.dp_source_id);
        if (matched_source && matched_source[0]) {
          this.selected_dp_card = matched_source[0];
        }
      }
    }
    if (this.selected_recurring_card == undefined) {
      if (this.recurring_source_id) {
        const matched_source1 = this.patientData['payment_sources'].filter(source => source.source_id == this.recurring_source_id);
        if (matched_source1 && matched_source1[0]) {
          this.selected_recurring_card = matched_source1[0];
        }
      }
    }

    let card_primary_sources_1 = [];
    let card_recurring_sources_1 = [];
    let card_backup_sources_1 = [];

    if (this.contractToken && data && data[this.contractToken]) {

      // tslint:disable-next-line:max-line-length
      card_primary_sources_1 = this.patientData['primary_sources'].filter(item => {
        return item.source_id == (this.dp_source_id || data[this.contractToken] && data[this.contractToken].dp_source_id)
      });
      // tslint:disable-next-line:max-line-length
      card_recurring_sources_1 = this.patientData['recurring_sources'].filter(item => {
        return item.source_id == (this.recurring_source_id || data[this.contractToken] && data[this.contractToken].recurring_source_id)
      });
      // tslint:disable-next-line:max-line-length
      card_backup_sources_1 = this.patientData['backup_sources'].filter(item => {
        return item.source_id == (this.backup_source_id || data[this.contractToken] && data[this.contractToken].backup_source_id)
      });
    }

    if (card_primary_sources_1.length == 0) {
      this.dp_source_id = 0;
    }
    if (card_recurring_sources_1.length == 0) {
      this.recurring_source_id = 0;
    }
    if (card_backup_sources_1.length == 0) {
      this.backup_source_id = 0;
    }
    if (this.planInfo.allow_one_card == 1) {
      if (this.dp_source_id == this.recurring_source_id) {
        this.planInfo.selected_payment_matrix.backup_required = 0;
      } else if (this.dp_source_id && this.recurring_source_id) {
        // tslint:disable-next-line:max-line-length
        if (this.selected_dp_card && this.selected_dp_card.fingerprint && this.selected_recurring_card && this.selected_recurring_card.fingerprint && this.selected_dp_card.fingerprint == this.selected_recurring_card.fingerprint) {
          this.planInfo.selected_payment_matrix.backup_required = 0;
        }
      }
      // tslint:disable-next-line:max-line-length
    } else if (this.selected_dp_card && this.selected_recurring_card && this.selected_dp_card.fingerprint == this.selected_recurring_card.fingerprint) {
      this.planInfo.selected_payment_matrix.backup_required = 1;
    }

    // tslint:disable-next-line:max-line-length
    if (this.selected_dp_card && this.selected_recurring_card && this.selected_dp_card.fingerprint !== this.selected_recurring_card.fingerprint && this.planInfo.payment_matrix_array[0].backup_required) {
      this.planInfo.selected_payment_matrix.backup_required = 1;
    }
    else if (this.selected_dp_card == undefined && this.planInfo.payment_matrix_array[0].backup_required == 1 && (this.planInfo && this.planInfo.selected_plan && this.planInfo.selected_plan.total_payable_amount > 0)) {
      this.planInfo.selected_payment_matrix.backup_required = 1;
    }
    else {
      this.planInfo.selected_payment_matrix.backup_required = 0;
    }
    if (data && data[this.contractToken] && data[this.contractToken].opened_step) {
      this.opened_step = data[this.contractToken].opened_step;
    }
  }
  setData(data: any) {
    this.planInfo = data.split_request_data[0];
    this.enrollmentfee = this.planInfo.plans_array[0].enrollment_fee ? this.planInfo.plans_array[0].enrollment_fee : 0;
    // console.log(this.enrollmentfee);
    if (this.planInfo.selected_payment_matrix == undefined) {
      this.planInfo.selected_payment_matrix = {
        backup_required: 0,
        backup_type: 2,
        primary_type: 2,
        recurring_type: 2
      }
    }

    this.planInfo.patient_address = this.planInfo.patient_address && this.planInfo.patient_address !== null ? this.planInfo.patient_address : this.patientData['patient_address'];
    this.planInfo.zip = this.planInfo.zip && this.planInfo.zip !== null ? this.planInfo.zip : this.patientData['zip'];
    this.planInfo.state = this.planInfo.state && this.planInfo.state !== null ? this.planInfo.state : this.patientData['state_name'];
    this.planInfo.state_code = this.planInfo.state_code && this.planInfo.state_code !== null ? this.planInfo.state_code : this.patientData['state_code'];
    this.planInfo.city = this.planInfo.city && this.planInfo.city !== null ? this.planInfo.city : this.patientData['city'];
    if (this.actual_matrix == undefined && this.new_bank_added != 1) {
      this.actual_matrix = JSON.parse(JSON.stringify(this.planInfo.selected_payment_matrix));
    }
    if (this.dp_source_id && this.recurring_source_id && this.dp_source_id == this.recurring_source_id) {
      this.planInfo.selected_payment_matrix.backup_required = 1;
    } else {
      this.planInfo.selected_payment_matrix.backup_required = 0;
    }

    this.checkPaymentSources();

    if (this.planInfo.start_date && this.planInfo.end_date) {

      let today = new Date();
      let start_date = new Date(this.planInfo.start_date);

      if (today > start_date) {
        start_date = new Date(new Date().setDate(new Date().getDate() + 1));
      }
      // tslint:disable:radix
      const first_recurring_days = data.split_request_data[0].first_recurring_days ? data.split_request_data[0].first_recurring_days : 0;
      this.planInfo.min_date = new Date(parseInt(this.datePipe.transform(start_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(start_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(start_date, 'dd', this.timezone)) + (this.planInfo.recurring_days - 1));
      let rec_days = this.planInfo && this.planInfo.contract_type == 6 ? this.planInfo.first_recurring_days_deferred : this.planInfo.split_plan_gap_days;

      this.planInfo.max_date = new Date(parseInt(this.datePipe.transform(this.planInfo.end_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(this.planInfo.end_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(this.planInfo.end_date, 'dd', this.timezone)) + (rec_days || 30));
      if (this.planInfo.is_ar_contract == 1) {
        const rec_days_ar = this.planInfo && this.planInfo.contract_type == 5 ? this.planInfo.first_recurring_days_ar : first_recurring_days;
        const add_1_month = new Date(parseInt(this.datePipe.transform(start_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(start_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(start_date, 'dd', this.timezone)) + ((rec_days_ar) - 1));
        this.planInfo.max_date = add_1_month;
        const end_date = new Date(parseInt(this.datePipe.transform(this.planInfo.start_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(this.planInfo.start_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(this.planInfo.start_date, 'dd', this.timezone)) + (rec_days_ar));
        if (add_1_month > end_date) {
          this.paymentDetails.recurringDate = this.planInfo.max_date;
        } else {
          this.planInfo.max_date = end_date;
          this.paymentDetails.recurringDate = add_1_month;
        }
        if (this.planInfo.ar_flow_immediate) {
          this.paymentDetails.recurringDate = moment().add(30, 'd').format(this.mainService.placeFormat);
        }
      }
      else {
        rec_days = this.planInfo && this.planInfo.contract_type == 6 ? this.planInfo.first_recurring_days_deferred : first_recurring_days;

        const add_1_month = new Date(parseInt(this.datePipe.transform(start_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(start_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(start_date, 'dd', this.timezone)) + ((rec_days) - 1));
        const end_date = new Date(parseInt(this.datePipe.transform(this.planInfo.end_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(this.planInfo.end_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(this.planInfo.end_date, 'dd', this.timezone)) + (rec_days));
        if (add_1_month > end_date) {
          this.planInfo.max_date = end_date;
          this.paymentDetails.recurringDate = this.planInfo.max_date;
        } else {
          this.paymentDetails.recurringDate = add_1_month;
        }
      }
      this.planInfo.max_date = this.paymentDetails.recurringDate;
      // setting pre-selected last date from the calendar in AR and now in financing as well.
      // if (this.planInfo && this.planInfo.is_ar_contract == 1) {
      // this.paymentDetails.recurringDate = this.planInfo.max_date;
      // }
      this.planInfo.selected_plan = this.planInfo.plans_array[this.selectedPlanIndex];
      if (this.creditReportOption) {
        this.planInfo.selected_plan['recurring_amount_with_credit_fee'] = +this.planInfo.selected_plan.recurring_amount + +this.planInfo.credit_report_amount;
        this.planInfo.selected_plan['creditReportOption'] = true;
        this.planInfo.selected_plan['advance_interest_amount_with_credit_fee'] = this.planInfo.selected_plan['recurring_amount_with_credit_fee'];
      }
    }
    if (this.planInfo.request_from != 0) {
      if (this.planInfo.next_payment_start_date && this.planInfo.next_payment_end_date) {
        if (this.mainService.getExactDate(new Date(this.planInfo.next_payment_end_date)) > this.mainService.getExactDate(new Date())) {
          this.paymentDetails.recurringDate = this.mainService.getExactDate(new Date(this.planInfo.next_payment_start_date)) > this.mainService.getExactDate(new Date()) ? this.mainService.getExactDate(new Date(this.planInfo.next_payment_start_date)) : new Date(new Date().setDate(new Date().getDate() + 1));
          this.planInfo.min_date = this.paymentDetails.recurringDate;
          this.planInfo.max_date = this.mainService.getExactDate(new Date(this.planInfo.next_payment_end_date));
        } else if (this.planInfo.next_payment_buffer_days && this.planInfo.next_payment_buffer_days > 0) {
          this.paymentDetails.recurringDate = new Date(new Date().setDate(new Date().getDate() + 1));
          this.planInfo.min_date = new Date(new Date().setDate(new Date().getDate() + 1));
          this.planInfo.max_date = new Date(parseInt(this.datePipe.transform(new Date(), 'yyyy', this.timezone)), parseInt(this.datePipe.transform(new Date(), 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(new Date(), 'dd', this.timezone)) + this.planInfo.next_payment_buffer_days);
        }
      } else if (this.planInfo.next_payment_buffer_days && this.planInfo.next_payment_buffer_days > 0) {
        this.paymentDetails.recurringDate = new Date(new Date().setDate(new Date().getDate() + 1));
        this.planInfo.min_date = new Date(new Date().setDate(new Date().getDate() + 1));
        this.planInfo.max_date = new Date(parseInt(this.datePipe.transform(new Date(), 'yyyy', this.timezone)), parseInt(this.datePipe.transform(new Date(), 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(new Date(), 'dd', this.timezone)) + this.planInfo.next_payment_buffer_days);
      }
    }
    this.calculateTotalPayable();

    if (this.planInfo && this.planInfo.show_closure_form) {
      this.show_closure_form = 1;
    }

    let tilaData = JSON.parse(localStorage.getItem('iframe_tila_data')) || {};

    tilaData['contract_patient_token'] = data.split_request_data[0].contract_patient_token;
    tilaData['contract_type'] = data.split_request_data[0].contract_type;
    tilaData.credit_report_status = this.creditReportOption?1:0;
    tilaData = { ...tilaData, ...data.financing_info[0], start_date: this.paymentDetails.recurringDate };
    // tslint:disable-next-line:max-line-length
    tilaData.start_date = new Date(new Date(this.paymentDetails.recurringDate).setDate(new Date(this.paymentDetails.recurringDate).getDate() + 1));
    localStorage.setItem('iframe_tila_data', JSON.stringify(tilaData));
    tilaData = { ...tilaData, ...data.financing_info[0] };
    localStorage.setItem('iframe_tila_data', JSON.stringify(tilaData));
  }

  calculateTotalPayable() {
    let fixed_flat_fee = this.planInfo && this.planInfo.enrollment_enabled ? 0 : this.enrollmentfee;
    fixed_flat_fee = this.is_waived ? 0 : fixed_flat_fee;
    if (this.planInfo && this.planInfo.plans_array && this.planInfo.plans_array.length > 0) {
      this.planInfo.plans_array.forEach((item: any) => {
        if (this.planInfo.contract_type === 1) {
          if (this.planInfo.payment_reserve_on_pay) {
            item.advance_interest_amount = item.recurring_amount;
          } else {
            item.advance_interest_amount = 0;
          }
        } else if (this.planInfo.contract_type === 3) {
          if (this.planInfo.payment_reserve_on_pay_new_ten) {
            item.advance_interest_amount = item.recurring_amount;
          } else {
            item.advance_interest_amount = 0;
          }
        } else {
          item.advance_interest_amount = item.advance_interest_amount ? parseFloat(parseFloat(
            item.advance_interest_amount
          ).toFixed(2)) : 0;
        }
        // tslint:disable-next-line:max-line-length
        item.total_payable_amount = parseFloat(this.planInfo.downpayment_amount) + parseFloat(fixed_flat_fee.toString()) + this.mainService.getCalculatedTransactionFee(this.planInfo, this.planInfo.downpayment_amount) + parseFloat(item.advance_interest_amount) + this.mainService.getCalculatedTransactionFee(this.planInfo, item.advance_interest_amount);
      });
    }
  }

  back() {
    if (this.payment_step == 1) {
      this.router.navigateByUrl('/plans/' + this.contractToken);
    } else {
      this.payment_step--;
    }
    this.setNavigationData();
  }

  ShowStripeElement() {
    this.mainService.stripe_element.update({
      hidePostalCode: false
    });
    // this.mainService.stripe_element.mount('#card-element');
    this.mainService.stripe_element.addEventListener('change', ({ data, error }) => {
      if (error) {
        this.cardError = error.message;
      } else {
        this.cardError = '';
      }
    });
  }

  createStripeToken() {
    if (!this.paymentDetails.recurringDate || this.paymentDetails.recurringDate == 'Invalid Date') {
      this.toaster.message('Please choose date', 3);
      return false;
    }

    if (!this.paymentDetails.cardName || (this.paymentDetails.cardName && !this.paymentDetails.cardName?.trim())) {
      this.toaster.message('Please Enter Card Holder Name', 3);
      return false;
    }

    if (this.cardError) {
      this.toaster.message('Please enter your card details', 3);
      return false;
    }

    if (!this.check_business_terms) {
      this.toaster.message('Please accept Business terms & conditions', 3);
      return false;
    }
    // if (!this.signature) {
    //   this.toaster.message('warning', 'Please add your signature');
    //   return false;
    // }

    if (!this.terms) {
      this.toaster.message('Please accept terms & conditions', 3);
      return false;
    }

    if (this.show_closure_form && this.patient_address && !this.patient_address.value.address) {
      this.toaster.message('Please enter address', 3);
      return false;
    }

    if (this.show_closure_form && !this.closure_terms) {
      this.toaster.message('Please accept consumer payment plan agreement', 3);
      return false;
    }

    let data = {
      name: this.paymentDetails.cardName
    };
    this.mainService.setLoader(true);
    this.mainService.stripe.createToken(this.mainService.stripe_element, data).then((response: any) => {
      if (response) {
        if (response.error) {
          this.mainService.setLoader(false);
          this.toaster.message(response.error.message, 3)
        }
        if (response.token) {
          this.dp_last4 = response.token.card.last4;
          this.recurring_last4 = response.token.card.last4;
          this.recurring_date = this.datePipe.transform(this.paymentDetails.recurringDate, 'MM/dd/yyyy');
          this.mainService.setLoader(false);
          this.paymentDetails.stripeToken = response.token.id;
          this.recurring_token = '';
          this.askRecurringCardModal.show();
        }
      }
    });
  }

  async uploadBusinessSignature() {
    if (this.isSubmitted) {
      return;
    }
    if (this.patientData && this.patientData.total_automation_business && this.patientData.total_automation_business.length <= 0) {
      if (!this.mainService.signature) {
        this.mainService.customPopups("Please add Signature", 1);
        return;
      }
      this.paymentLoader = true;
      this.mainService.setLoader(true);
      const formData = new FormData();
      const screenshot = await this.screenshotService.captureElementAsBlob(this.screenManager.nativeElement);
      formData.append('patient_signature', this.mainService.signature);
      formData.append('screen_shot', screenshot, 'screenshot.jpg');

      this.proposal.formApi('post', 'upload_signature', formData)?.subscribe((data) => {
        if (data.is_error == 0) {
          this.paymentLoader = false;
          this.mainService.setLoader(false);
          this.createContract(data.patient_signature,data?.screen_shot)
        } else {
          this.mainService.customPopups(data.err, 1);
          this.paymentLoader = false;
          this.mainService.setLoader(false);
        }
      });
    } else {
      this.createContract(null)
    }
  }

  createContract(signature = null, screen_shot = null) {
    if (!this.terms) { }
    if (!this.dp_source_id && !this.recurring_source_id && this.planInfo && this.planInfo.selected_plan && this.planInfo.selected_plan.total_payable_amount > 0) {
      this.mainService.customPopups("Please add Payment Card", 1);
      return;
    }
    if (!this.dp_source_id) {
      this.mainService.customPopups("Please add today's Payment Card.", 1);
      return;
    }
    if (!this.recurring_source_id) {
      this.mainService.customPopups("Please add recurring payment method.", 1);
      return;
    }
    if (!this.check_business_terms) {
      this.mainService.customPopups("Please accepet Terms & Conditions.", 1);
      return;
    }

    if (this.planInfo.selected_payment_matrix.backup_required && !this.backup_source_id) {
      this.mainService.customPopups("Please add a backup payment method.", 1);
      return;
    }

    if (!this.paymentDetails.recurringDate) {
      this.toaster.message('Please choose a valid recurring payment source.', 3);
      return;
    }
    if (this.recurring_source_id && this.backup_source_id && this.getMyCard(this.recurring_source_id, 'recurring_sources').fingerprint === this.getMyCard(this.backup_source_id, 'backup_sources').fingerprint) {
      this.toaster.message("Recurring payment method and backup payment method cannot be same", 3);
      return;
    }
    if (this.planInfo.selected_payment_matrix.backup_required && !this.backup_source_id) {
      this.toaster.message('Please add Backup Payment Method.', 3);
      return;
    }

    const contract_metadata = {
      allowed: {
        primary: this.actual_matrix.primary_type,
        recurring: this.actual_matrix.recurring_type,
        backup: this.actual_matrix.backup_type,
      },
      selected: {
        primary: this.selected_dp_card ? this.selected_dp_card.payment_source_type == 1 ? 1 : 2 : 0,
        recurring: this.selected_recurring_card ? this.selected_recurring_card.payment_source_type == 1 ? 1 : 2 : 0,
        backup: this.selected_backup_card ? this.selected_backup_card.payment_source_type == 1 ? 1 : 2 : 0.
      },
      last4: {
        // this.selected_recurring_card && this.selected_recurring_card.last4 ? this.selected_recurring_card.last4 : ''
        primary: this.selected_dp_card && this.selected_dp_card.last4 ? this.selected_dp_card.last4 : '',
        recurring: this.selected_recurring_card && this.selected_recurring_card.last4 ? this.selected_recurring_card.last4 : '',
        backup: this.selected_backup_card && this.selected_backup_card.last4 ? this.selected_backup_card.last4 : ''
      },
      source_id: {
        // this.selected_recurring_card && this.selected_recurring_card.source_id ? this.selected_recurring_card.source_id : 0
        primary: this.selected_dp_card && this.selected_dp_card.source_id ? this.selected_dp_card.source_id : 0,
        recurring: this.selected_recurring_card && this.selected_recurring_card.source_id ? this.selected_recurring_card.source_id : 0,
        backup: this.selected_backup_card && this.selected_backup_card.source_id ? this.selected_backup_card.source_id : 0
      },
      created_from: 1
    };


    const fixDateFOrmat = () => {
      const dateMerge = moment(this.paymentDetails.recurringDate, this.mainService.placeFormat).format('YYYY-MM-DD');
      console.log(dateMerge);
      return dateMerge
    };
    let body = {
      contract_patient_token: this.contractToken,
      patient_signature: signature,
      screen_shot: screen_shot,
      contract_type: this.planInfo.contract_type,
      start_date: fixDateFOrmat(),
      payment_source_type: '3',
      device_info: JSON.stringify(this.mainService.device_info()),
      patient_address: this.patient_address.value.address,
      patient_zip: this.patient_address.value.zip,
      source_id: String(this.dp_source_id ? this.dp_source_id : this.recurring_source_id),
      contract_metadata: JSON.stringify(contract_metadata),
      language_preffered: this.patient_address.value.language_preffered,
      skip_authrization: 'true',
      charge_flow: this.charge_flow,
      is_generate_signature: this.mainService.is_generate_signature,
      credit_report_status: +this.creditReportOption ? 1 : 0
    }

    if (this.recurring_source_id == -1) {
      body['bank_recurring_source_id'] = String(-1)
    } else {
      body['recurring_source_id'] = String(this.recurring_source_id)
    }

    if (this.backup_source_id == -1) {
      body['bank_alternate_recurring_source_id'] = '-1';
    } else if (this.backup_source_id) {
      body['alternate_recurring_source_id'] = String(this.backup_source_id);
    } else {
      body['bank_alternate_recurring_source_id'] = '-1';
    }

    if (this.modalRef) { this.modalRef.hide(); }
    this.mainService.setLoader(true);
    if (this.paymentLoader) {
      return false;
    } else {
      this.payment_error = '';
      this.paymentLoader = true;
      this.proposal.formApi('post', 'pay_split_pf', body)
        .subscribe((data: any) => {
          this.paymentLoader = false;
          this.mainService.setLoader(false);
          if (this.confirmPaymentModal) {
            this.confirmPaymentModal.hide();
          }
          if (data && typeof data == 'string') {
            data = JSON.parse(data);
          }
          if (data.is_error == 1) {
            this.charge_flow = this.charge_flow == 1 ? 2 : 1;
            if (data.flag === 585) {
              this.toaster.message(data.err || data.override_text, 3);
              this.router.navigate(['plans', this.contractToken]);
              return false;
            }
            this.card_payment_tried = data.card_payment_tried;
            if (data.override_text && (data.is_financed || data.is_expired)) {
              this.toaster.message(data.override_text, 3);
              setTimeout(() => {
                this.router.navigate(['plans', this.contractToken]);
              }, 3000);
              return false;
            } else {
              this.RemoveStripeElement('secondary_card');
              this.AddStripeElement('card-element');
              this.mainService.saveFinancingError({ payment_intent_id: data && data.data && data.data.client_secret, contract_token: this.contractToken, error_message: (data.override_text || data.err), error_type: "createContract" });
              this.payment_error = data.override_text || data.err;
              this.paymentFail.show();
            }
          }

          if (data.is_error == 0 && (data && data.data && data.data.require_customer_action)) {
            localStorage.setItem('contract_code', data && data.data && data.data.contract_code);
            this.paymentLoader = true;
            this.mainService.setLoader(true);
            this.mainService.stripe.confirmPayment({
              clientSecret: data?.data?.client_secret,
              redirect: 'if_required'
            }).then((res) => {
              if (res && res.paymentIntent && res.paymentIntent.id) {
                // this.mainService.current_step = 5;
                this.goToCustomerDetails();
                if (Number(this.selected_dp_card && this.selected_dp_card.payment_source_type) === 1) {
                  if (this.dp_source_id == -1) {
                    this.success_message = "Your contract has been created in pending state.\nAfter you verify your micro-deposits and we receive payment from your bank, your contract will be fully active!"
                  } else {
                    this.success_message = "Your contract has been created.\nAfter we receive payment from your bank, your contract will be fully active!"
                  }
                }
                this.contract_code = data.data.contract_code;
                if (this.confirmPaymentModal) {
                  this.confirmPaymentModal.show();
                }
              } else if (res.error && res.error['message']) {
                this.charge_flow = this.charge_flow == 1 ? 2 : 1;
                this.mainService.saveFinancingError({ payment_intent_id: data?.data?.client_secret, contract_token: this.contractToken, error_message: res.error['message'], error_type: "createContract" });
                this.mainService.customPopups(res.error['message'], 1);
              }
              this.paymentLoader = false;
              this.mainService.setLoader(false);
                this.isSubmitted = false;
            }).catch((err) => {
                this.isSubmitted = false;
              this.charge_flow = this.charge_flow == 1 ? 2 : 1;
              this.mainService.setLoader(false);
              this.mainService.saveFinancingError({ payment_intent_id: data?.data?.client_secret, contract_token: this.contractToken, error_message: err, error_type: "createContract" });
              this.mainService.customPopups(err, 1);
            });
          } else {
            this.isSubmitted = false;
            if (data.is_error == 0) {
              this.goToCustomerDetails();
              if (Number(this.selected_dp_card && this.selected_dp_card.payment_source_type) === 1) {
                if (this.dp_source_id == -1) {
                  this.success_message = "Your contract has been created in pending state.\nAfter you verify your micro-deposits and we receive payment from your bank, your contract will be fully active!"
                } else {
                  this.success_message = "Your contract has been created.\nAfter we receive payment from your bank, your contract will be fully active!"
                }
              }
              this.contract_code = data.contract_code;
              if (this.confirmPaymentModal) {
                this.confirmPaymentModal.show();
              }
            } else if (data.is_error == 1) {
              this.charge_flow = this.charge_flow == 1 ? 2 : 1;
              this.mainService.saveFinancingError({ payment_intent_id: data?.data?.client_secret, contract_token: this.contractToken, error_message: data.err || data.override_text, error_type: "createContract" });
              this.toaster.message(data.err || data.override_text, 3);
              return false;
            }
          }
          },(error: any) => {
            this.isSubmitted = false;
            this.paymentLoader = false;
            this.mainService.setLoader(false);
          this.charge_flow = this.charge_flow == 1 ? 2 : 1;
          this.paymentLoader = false;
          this.mainService.setLoader(false);
          this.mainService.saveFinancingError({ payment_intent_id: "request_token", contract_token: this.contractToken, error_message: error.message, error_type: "createContract" });

          this.mainService.customPopups(error.message, 1);
        });
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-md modal-445 modal-dialog-centered', ignoreBackdropClick: true, keyboard: false });
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.modalRef.hide();
      }
    });
  }

  goToCustomerDetails() {
    // this.confirmPaymentModal.hide();
    this.router.navigateByUrl('/personal-details/' + this.contractToken);
  }

  showElementTrigger(event) {
    this.showElement = event;
    setTimeout(() => {
      this.openAddCardBankPopup(false, this.payment_source_type);
    }, 500);
  }

  retryPayment() {
    this.createStripeToken();
  }

  changeCard() {
    this.payment_step = 1;
    this.opened_step = 1;
    this.paymentDetails.cardName = '';
    this.mainService.stripe_element.clear();
    this.modalRef.hide();
  }

  openWriteToUsModal() {
    if (this.modalService.getModalsCount() > 0) {
      this.modalRef.hide();
    }
    const initialState = { data: this.planInfo };
    this.modalRef = this.modalService.show(WriteToUsComponent, { initialState });
    this.modalRef.setClass('modal-445')
  }

  openCallbackModal() {
    if (this.modalService.getModalsCount() > 0) {
      this.modalRef.hide();
    }
    const initialState = { data: this.planInfo };
    this.modalRef = this.modalService.show(CallbackComponent, { initialState });
    this.modalRef.setClass('modal-445')
  }
  AddStripeElement(element_id) {
    this.selected_card = '';
    return;
    if (element_id == 'card-element' || element_id == 'add_new_card' || element_id == 'add_new_card1') {
      this.mainService.stripe_element.update({
        hidePostalCode: false
      });
    } else {
      this.mainService.stripe_element.update({
        hidePostalCode: true
      });
    }
    setTimeout(() => {
      this.mainService.stripe_element.mount('#' + element_id);
    }, 1000);
  }
  RemoveStripeElement(element_id) {
    this.mainService.stripe_element.unmount('#' + element_id);
  }
  GetStripeToken(button_action) {
    this.buttonClickedSubject.next(button_action);
  }

  addAddress() {
    if (!this.paymentDetails.recurringDate || this.paymentDetails.recurringDate == 'Invalid Date') {
      this.toaster.message('Please choose date', 3);
      return false;
    }

    if (!this.paymentDetails.cardName) {
      this.toaster.message('Please enter cardholder name', 3);
      return false;
    }

    if (this.cardError) {
      this.toaster.message('Please enter your card details', 3);
      return false;
    }
    if (this.patient_address && this.patient_address.value.patient_first_name && this.patient_address.value.patient_last_name && this.patient_address.value.address && this.patient_address.value.zip && this.patient_address.value.zip != '' && this.patient_address.value.zip != null) {
      this.addAddressModal.show();
    } else if (this.planInfo && this.planInfo.apf_patient_first_name && this.planInfo.apf_patient_email) {
      this.patient_address.controls.patient_first_name.setValue(this.planInfo.apf_patient_first_name);
      this.patient_address.controls.patient_last_name.setValue(this.planInfo.apf_patient_last_name);
      this.patient_address.controls.patient_email.setValue(this.split_request_data[0].patient_email || this.planInfo.apf_patient_email);

      if (this.planInfo.apf_patient_mobile && this.planInfo.apf_patient_mobile.split('-').length > 1) {
        this.patient_address.controls.patient_mobile.setValue(this.planInfo.apf_patient_mobile.split('-')[1]);
      }
      if (this.planInfo && this.planInfo.patient_address && this.planInfo.zip && this.planInfo.zip != '' && this.planInfo.zip != null) {
        this.patient_address.controls.address.setValue(this.planInfo.patient_address);
        this.patient_address.controls.city.setValue(this.planInfo.city);
        this.patient_address.controls.state_name.setValue(this.planInfo.state);
        // this.patient_address.controls.state.setValue(this.planInfo.state);
        this.patient_address.controls.zip.setValue(this.planInfo.zip);
        this.patient_address.controls.city_id.setValue(this.planInfo.city_id);

        if (this.patient_address.value.zip) {
          this.zips = [{ zip: this.patient_address.value.zip, state_name: this.patient_address.value.state_name, city: this.patient_address.value.city, city_id: this.patient_address.value.city_id }];
        }
      }
      this.addAddressModal.show();
    } else {
      this.zipClear('', 1);
      this.addAddressModal.show();
    }
  }

  getZip(token: string, type: number) {
    this.zipClear('', type);
    if (token.length > 3 && token.length <= 6) {
      this.loadingZip = true;
      this.mainService
        .getZipcode({
          zipcode: token,
          search_canada: 1
        })
        .subscribe(
          (data: any) => {
            if (data && data.zip_info) {
              if (type === 1) {
                this.zips = data.zip_info;
              }
            }
            this.loadingZip = false;
          },
          (error: any) => {
            this.loadingZip = false;
          }
        );
    } else {
      return false;
    }
  }
  selectZip(selectedCity: any, type: any) {
    if (type == 1) {
      const zip = this.zips.filter(item => item.zip === selectedCity)[0] ? this.zips.filter(item => item.zip === selectedCity)[0] : [];
      this.patient_zip = zip;
      this.selectedZip = zip.zip;
      this.patient_address.controls.city_id.setValue(zip.city_id);
      this.patient_address.controls.city.setValue(zip.city);
      this.patient_address.controls.state_name.setValue(zip.state_name);
      this.patient_address.controls.zip.setValue(zip.zip);
      this.patient_address.controls.zipSelected.setValue(true);
      this.patient_address.updateValueAndValidity();
    }

  }

  zipClear(event: any, type: any) {
    if (type == 1) {
      this.patient_zip = {
        zip: '',
        city: '',
        city_id: '',
        city_name: '',
        state_name: '',
      };
      this.patient_address.controls.city_id.setValue(null);
      this.patient_address.controls.city.setValue(null);
      this.patient_address.controls.state_name.setValue(null);
      this.patient_address.controls.zip.setValue(null);
      this.patient_address.controls.zipSelected.setValue(false);
      this.patient_address.updateValueAndValidity();
    }
  }

  async addAddressFn(form) {
    if (!form) {
      form.markAsTouched();
    }

    // tslint:disable-next-line:max-line-length
    if (this.patient_address && !this.patient_address.value.patient_first_name || this.patient_address.value.patient_first_name?.trim().length == 0) {
      // this.toaster.message('warning', 'Please enter First Name', '');
      if (this.el.nativeElement.querySelector('[name="patient_first_name"]')) {
        this.el.nativeElement.querySelector('[name="patient_first_name"]').focus();
      }
      this.showvalidation = true;
      return;
    }
    // tslint:disable-next-line:max-line-length
    if (this.patient_address && !this.patient_address.value.patient_last_name || this.patient_address.value.patient_last_name?.trim().length == 0) {
      // this.toaster.message('warning', 'Please enter Last Name', '');
      if (this.el.nativeElement.querySelector('[name="patient_last_name"]')) {
        this.el.nativeElement.querySelector('[name="patient_last_name"]').focus();
      }

      return;
    }
    if (this.patient_address && !this.patient_address.value.language_preffered || this.patient_address.value.language_preffered?.trim().length == 0) {
      this.toaster.message('Please Select Preferred Language', 3);
      return
    }
    // tslint:disable-next-line:max-line-length
    if (!this.patient_address.controls.patient_email.disabled && this.patient_address && !this.patient_address.value.patient_email || (this.patient_address.value.patient_email && this.patient_address.value.patient_email?.trim().length == 0)) {
      // this.toaster.message('warning', 'Please enter Email', '');
      return;
    }
    if (this.patient_address && !this.patient_address.value.address || this.patient_address.value.address?.trim().length == 0) {
      // this.toaster.message('warning', 'Please enter Address', '');
      this.showvalidation = true;

      if (this.el.nativeElement.querySelector('[name="search_field"]')) {
        this.el.nativeElement.querySelector('[name="search_field"]').focus();
      }
      return;
    }
    if (this.patient_address && !this.patient_address.controls?.zip.value || this.patient_address.controls?.zip.value?.trim().length == 0) {
      // this.toaster.message('warning', 'Please enter Zip/Postal code', '');
      if (this.el.nativeElement.querySelector('[name="address"]')) {
        this.el.nativeElement.querySelector('[name="address"]').focus();
      }
      this.showvalidation = true;

      return;
    }

    if (!new RegExp(this.mobile_pattern).test(this.patient_address.controls.patient_mobile_country_code.value + this.patient_address.value.patient_mobile)) {
      // this.toaster.message('warning', 'Please enter a valid phone number', '');
      if (this.el.nativeElement.querySelector('[name="patient_mobile"]')) {
        this.el.nativeElement.querySelector('[name="patient_mobile"]').focus();
      }
      return;
    }
    const invalid_ssn = ['002281852', '042103580', '062360749', '078051120', '095073645', '128036045', '135016629', '141186941', '165167999', '165187999', '165207999', '212099999', '165227999', '306302348', '165247999', '189092294', '308125070', '212097694', '549241889', '468288779'];
    console.log(this.patient_address.value.patient_ssn, this.patientData['patient_ssn']);

    if (this.mainService.currency_data.country_code == 'US' || this.mainService.currency_data.country_code == "CA") {
      if (!this.mainService.validateSSN(this.patient_address && this.patient_address.value && this.patient_address.value.patient_ssn ? this.patient_address.value.patient_ssn : this.patientData['patient_ssn'])) {
        this.patient_address.get("patient_ssn").enable();
        this.patient_address.get("patient_ssn").setValue('');
        this.patient_address.get("patient_ssn").setErrors({ err: 'Please enter a valid ' + this.mainService.document_label });
        if (this.el.nativeElement.querySelector('[name="patient_ssn"]')) {
          this.el.nativeElement.querySelector('[name="patient_ssn"]').focus();
        }
        return;
      }
      else {
        console.error("else flow inside this.patient_address.controls.patient_ssn error block", this.patient_address.get("patient_ssn"));
      }
    } else {
      if (this.showSSNfields && !this.mainService.validateCountry(this.patient_address.controls.patient_ssn.value)) {
        this.patient_address.get("patient_ssn").enable();
        this.patient_address.get("patient_ssn").setValue('');
        this.patient_address.get("patient_ssn").setErrors({ err: 'Please enter a valid ' + this.mainService.document_label });
        if (this.el.nativeElement.querySelector('[name="patient_ssn"]')) {
          this.el.nativeElement.querySelector('[name="patient_ssn"]').focus();
        }
        return;
      }
    }
    if (this.patient_address.invalid) {
      this.showvalidation = true;
      return;
    }
    this.errorMsg = '';
    this.showvalidation = false;

    // tslint:disable-next-line:max-line-length
    const pattern = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    // tslint:disable-next-line:max-line-length
    if (!this.patient_address.controls.patient_email.disabled && (this.patient_address.value.patient_email && !pattern.test(this.patient_address.value.patient_email))) {
      this.toaster.message('Please enter a valid Email', 3);
      return;
    }
    let getCityId = this.patient_address.get('city_id')?.value;
    if(!getCityId || this.editAddressManually) {
       await this.getZipCodeData(!this.editAddressManually ? getCityId : '');
       getCityId = this.patient_address.get('city_id')?.value;
    }
    if (getCityId) {
      const params = {
        contract_patient_token: this.contractToken,
        address: this.patient_address.value.address_2 ? this.patient_address.value.address + " || " + this.patient_address.value.address_2 : this.patient_address.value.address,
        city_id: this.patient_address.value.city_id || this.patient_zip.city_id,
        patient_first_name: this.patient_address.value.patient_first_name,
        patient_last_name: this.patient_address.value.patient_last_name,
        // tslint:disable-next-line:max-line-length
        patient_email: this.split_request_data[0].patient_email || this.patient_address.value.patient_email || this.patientData['patient_email'],
        patient_mobile: this.patient_address.value.patient_mobile.replace(/[^0-9]/g, ''),
        patient_ssn: this.patient_address.value.patient_ssn || this.patientData['patient_ssn'],
        from_plans: '1',
        patient_mobile_country_code: this.patient_address.controls.patient_mobile_country_code.value,
        language_preffered: this.patient_address.value.language_preffered
      };
      this.mainService.setLoader(true);
      if (this.paymentLoader) {
        return false;
      } else {
        this.paymentLoader = true;
        this.proposal.formApi('post', 'add_patient_address', { ...params })
          .subscribe((data: any) => {
            this.paymentLoader = false;
            this.mainService.setLoader(false);
            if (data && typeof data == 'string') {
              data = JSON.parse(data);
            }
            if (data.is_error == 1) {
              if (data.override_text || data.err) {
                this.toaster.message(data.override_text || data.err, 3);
                return false;
              }
            }
            if (data.is_error == 0) {
              this.scrollToTop();
              if (this.split_request_data && this.split_request_data[0]?.ar_flow_immediate) {
                this.mainService.current_step = 4;
              } else {
                this.mainService.current_step = 3;
              }
              const zip = data.addressInfo;
              let address1 = zip.patient_address && zip.patient_address.includes("||") ? zip.patient_address.split("||")[0]?.trim() : zip.patient_address
              this.patient_address.controls.address.setValue(address1);
              this.patient_address.controls.city.setValue(zip.city);
              this.patient_address.controls.state_name.setValue(zip.state);
              // this.patient_address.controls.state.setValue(zip.state);
              this.patient_address.controls.zip.setValue(zip.zip);
              this.patient_address.controls.city_id.setValue(zip.city_id);
              this.patient_address.controls.patient_first_name.setValue(zip.patient_first_name);
              this.patient_address.controls.patient_last_name.setValue(zip.patient_last_name);
              this.patient_address.controls.patient_email.setValue(zip.patient_email);
              if (this.patient_address.value.zip) {
                // tslint:disable-next-line:max-line-length
                this.zips = [{ zip: this.patient_address.value.zip, state_name: this.patient_address.value.state_name, city: this.patient_address.value.city, city_id: this.patient_address.value.city_id }];
              }
              if (zip && zip.patient_mobile && zip.patient_mobile.split('-').length > 1) {
                this.patient_address.value.patient_mobile = zip.patient_mobile.split('-')[1];
              }
              // this.addAddressModal.hide();
              // this.confirmPaymentModal.show();
              // this.openModal(this.successModal);
            }
          }, (error: any) => {
            this.paymentLoader = false;
            this.mainService.setLoader(false);
          });
      }
    }

  }

  getZipCodeData(val) {
    return new Promise((resolve, reject) => {
      if (!val) {
        this.mainService.zipCode = {...this.mainService.zipCode, ...this.patient_address.value}; // for manually edit address
        if((!this.mainService?.zipCode?.zip || this.customZip) || (this.editAddressManually)) {
          this.mainService.zipCode['custom_zip'] = 1;
        } else {
          this.mainService.zipCode['custom_zip'] = 0;
        }
        this.mainService.zipCode.zip = this.patient_address.get('zip')?.value

        if (!this.mainService.zipCode['country_code']) {
          this.mainService.zipCode['country_code'] = this.mainService.defaultCountry['country_code'];
        }

        if (!this.mainService.zipCode['latitude'] && !this.mainService.zipCode['longitude']) {
          this.mainService.zipCode['latitude'] = this.mainService.zipCode['longitude'] = 0
        }

        this.mainService.getZip(this.mainService.zipCode).subscribe((res:any) => {
          const data = res?.data;
          if (data && (data.city_id && !res.is_error)) {
            this.patient_address.get('city_id')?.setValue(data.city_id);
            resolve(res);
          } else {
            const message = data?.message || data?.err || data?.override_text || 'Something went wrong';
            this.mainService.customPopups(message, 1);
            reject(message);
          }
        });
      } else {
        console.log("error");
        reject("error");
      }
    })
  }

  acceptClosure(modal) {
    this.closure_terms = true;
    modal.hide();
    this.confirmPaymentModal.show();

  }

  detectChange() {
    this.cd.detectChanges();
  }

  resetRecurringModal() {
    this.askRecurringCardModal.hide();
    setTimeout(() => {
      this.addRecurringCardModal.show();
      this.GetStripeToken('clear');
    }, 100);
  }
  downPaymentAsRecurring() {
    this.askRecurringCardModal.hide();
    this.secondaryCardModal.show();
    this.RemoveStripeElement('card-element');
    this.AddStripeElement('secondary_card');
  }
  CatchStripeTokenForRecursiveCard(token_data) {
    this.alternate_recurring_source_id = this.paymentDetails.stripeToken;
    this.recurring_last4 = token_data.token.card.last4;
    this.recurring_date = this.datePipe.transform(this.paymentDetails.recurringDate, 'MM/dd/yyyy');
    this.recurring_token = token_data.token.id;
    this.addRecurringCardModal.hide();
    this.showConfirmationPopup();
  }
  CatchStripeTokenForSecondaryCard(token) {
    this.alternate_recurring_source_id = token;
    this.secondaryCardModal.hide();
    this.showConfirmationPopup();
  }
  showConfirmationPopup() {
    let array = [];
    if (this.planInfo) {
      if (this.planInfo.enrollment_enabled != 1) {
        // array.push(this.planInfo.is_ar_contract == 1 ? 'Account Setup Fee' : 'Enrollment Fee');
        array.push('Enrollment Fee');
      }
      if (this.planInfo.downpayment_amount) {
        array.push('Down Payment');
      }
      if (this.planInfo.selected_plan && this.planInfo.selected_plan.advance_interest_amount) {
        if (this.planInfo.contract_type == 2 || this.planInfo.contract_type == 4 || this.planInfo.contract_type == 5) {
          array.push('Upfront Payment');
        }
        if (this.planInfo.contract_type == 1 || this.planInfo.contract_type === 3) {
          array.push('First Recurring Payment');
        }
      }
    }
    this.payble_text = array.join(' + ');
    this.confirmPaymentModal.show();
  }
  paymentMethodValidation(type, funding_type) {
    if (this.mainService.featureList && this.mainService.featureList.length) {
      const featureFilter = this.mainService.featureList.find(item => item.feature_enum === 'PAYMENTMETHOD');
      const getFeature = featureFilter ? JSON.parse(JSON.stringify(featureFilter)) : {};
      if (getFeature && getFeature.payment_method) {
        getFeature.payment_method = JSON.parse(getFeature.payment_method);
        // tslint:disable-next-line:max-line-length
        if ((type + '').toLocaleUpperCase() != 'BANK' && funding_type && !getFeature.payment_method.includes((funding_type + '').toLocaleUpperCase())) {
          this.mainService.setLoader(false);
          this.toaster.message(`Payment type ${funding_type} is not supported as per your business plan`, 3);
          return false;
        } else {
          // tslint:disable-next-line:max-line-length
          if ((type + '').toLocaleUpperCase() === 'BANK' && !getFeature.payment_method.includes(('ACH').toLocaleUpperCase())) {
            this.mainService.setLoader(false);
            this.toaster.message(`Payment type BANK is not supported as per your business plan`, 3);
            return false;
          } else {
            return true;
          }
        }
      } else {
        this.mainService.setLoader(false);
        this.toaster.message(`Payment type is not supported as per your business plan.`, 3);
        return false;
      }
    }
  }
  nextStep(modal?) {
    if (this.payment_step == 1) {
      if (!this.dp_source_id) {
        this.opened_step = 1;
        this.toaster.message('Please add/select a payment method for the payment', 3);
        return false;
      }
      let matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.dp_source_id)
      if (matched_source && matched_source[0]) {
        this.selected_dp_card = matched_source[0];
      }
      if (this.selected_dp_card) {
        if (!this.paymentMethodValidation(this.selected_dp_card.payment_source, this.selected_dp_card.funding)) {
          return false;
        }
      }
      if (this.actual_matrix) {
        this.planInfo.selected_payment_matrix = JSON.parse(JSON.stringify(this.actual_matrix));
      }
      this.checkPaymentSources();
      this.payment_step = 2;
      this.opened_step = 2;
      setTimeout(() => {
        // this.initSignPad();
      }, 200);
    } else if (this.payment_step == 2) {
      if (!this.dp_source_id) {
        this.opened_step = 1;
        this.toaster.message('Please add/select a payment method for the payment', 3);
        return false;
      }
      if (!this.recurring_source_id) {
        this.opened_step = 2;
        this.toaster.message('Please add/select a payment method for the recurring payment', 3);
        return false;
      }
      let matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.recurring_source_id)
      if (matched_source && matched_source[0]) {
        this.selected_recurring_card = matched_source[0];
      }
      if (this.selected_recurring_card) {
        if (!this.paymentMethodValidation(this.selected_recurring_card.payment_source, this.selected_recurring_card.funding)) {
          return false;
        }
      }
      // if (!this.signature) {
      //   this.toaster.message('warning', 'Please add your signature');
      //   return false;
      // }

      this.show_backup = false;
      if (!this.terms) {
        this.opened_step = 2;
        this.toaster.message('Please accept terms & conditions', 3);
        return false;
      }

      if (!this.check_business_terms) {
        this.toaster.message('Please accept Business terms & conditions', 3);
        return false;
      }

      if (!this.signed) {
        this.opened_step = 2;
        this.toaster.message('Please acknowledge digitally signed contract', 3);
        return false;
      }

      if (this.actual_matrix) {
        this.planInfo.selected_payment_matrix = JSON.parse(JSON.stringify(this.actual_matrix));
      }
      if (this.selected_dp_card && this.selected_recurring_card && this.selected_dp_card.payment_source_type == 1 && this.selected_recurring_card.payment_source_type == 1) {
        this.planInfo.selected_payment_matrix.backup_required = 1;
      }
      if (this.selected_recurring_card && this.selected_recurring_card.payment_source_type == 1) {
        this.planInfo.selected_payment_matrix.backup_type = 2;
      }
      if (this.dp_source_id == this.recurring_source_id) {
        this.planInfo.selected_payment_matrix.backup_required = 1;
      } else if (this.selected_dp_card && this.selected_recurring_card && this.selected_dp_card.fingerprint == this.selected_recurring_card.fingerprint) {
        this.planInfo.selected_payment_matrix.backup_required = 1;
      }
      if (this.recurring_source_id == -1) {
        this.planInfo.selected_payment_matrix.backup_required = 1;
      }
      this.backup_source_id = null;
      this.selected_backup_card = {};
      this.checkPaymentSources();
      this.payment_step = 3;
      this.opened_step = 3;
    } else {
      if (this.planInfo.selected_payment_matrix.backup_required == 1 && !this.backup_source_id) {
        this.toaster.message('Please add/select a payment method for the backup payment', 3);
        return;
      }
      if (this.backup_source_id) {
        if (this.backup_source_id == this.recurring_source_id) {
          this.toaster.message('Recurring payment method and backup payment method cannot be same', 3);
          return;
        }
        let matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.backup_source_id)
        if (matched_source && matched_source[0]) {
          this.selected_backup_card = matched_source[0];
        }
      }
      if (this.selected_backup_card) {
        if (!this.paymentMethodValidation(this.selected_backup_card.payment_source, this.selected_backup_card.funding)) {
          return;
        }
      }
      if (this.selected_backup_card && this.selected_backup_card.fingerprint && this.selected_recurring_card && this.selected_recurring_card.fingerprint && this.selected_backup_card.fingerprint == this.selected_recurring_card.fingerprint) {
        this.toaster.message('Recurring payment method and backup payment method cannot be same', 3);
        return;
      }
      if (modal) {
        modal.hide();
      }
      this.fullyCheckTheContract();
    }
    this.mainService.scrollToTop();
    this.setNavigationData();
  }
  setNavigationData() {
    const obj = {};
    obj[this.contractToken] = {
      payment_step: this.payment_step,
      dp_source_id: this.dp_source_id,
      recurring_source_id: this.recurring_source_id,
      backup_source_id: this.backup_source_id
    };
    localStorage.setItem('navigation_data', JSON.stringify(obj));
  }
  fullyCheckTheContract() {
    if (!this.dp_source_id) {
      this.toaster.message("Please choose payment method for today's payment.", 3);
      this.payment_step = 1;
      this.setNavigationData();
      return false;
    }
    if (!this.recurring_source_id) {
      this.toaster.message("Please choose payment method for recurring payment.", 3);
      this.payment_step = 2;
      this.setNavigationData();
      return false;
    }
    if (this.show_closure_form) {
      // tslint:disable-next-line:max-line-length
      if (this.patient_address && this.patient_address.value.patient_first_name && this.patient_address.value.patient_last_name && this.patient_address.value.address && this.patient_address.value.zip && this.patient_address.value.zip != '' && this.patient_address.value.zip != null) {
        this.addAddressModal.show();
      } else if (this.planInfo && this.planInfo.apf_patient_first_name && this.planInfo.apf_patient_email) {
        this.patient_address.controls.patient_first_name.setValue(this.planInfo.apf_patient_first_name);
        this.patient_address.controls.patient_last_name.setValue(this.planInfo.apf_patient_last_name);
        this.patient_address.controls.patient_email.setValue(this.split_request_data[0].patient_email || this.planInfo.apf_patient_email);
        if (this.planInfo.apf_patient_mobile && this.planInfo.apf_patient_mobile.split('-').length > 1) {
          this.patient_address.controls.patient_mobile.setValue(this.planInfo.apf_patient_mobile.split('-')[1]);
        }
        if (this.planInfo && this.planInfo.patient_address && this.planInfo.zip && this.planInfo.zip != '' && this.planInfo.zip != null) {
          this.patient_address.controls.address.setValue(this.planInfo.patient_address);
          this.patient_address.controls.city.setValue(this.planInfo.city);
          this.patient_address.controls.state_name.setValue(this.planInfo.state);
          this.patient_address.controls.zip.setValue(this.planInfo.zip);
          this.patient_address.controls.city_id.setValue(this.planInfo.city_id);

          if (this.patient_address.value.zip) {
            // tslint:disable-next-line:max-line-length
            this.zips = [{ zip: this.patient_address.value.zip, state_name: this.patient_address.value.state_name, city: this.patient_address.value.city, city_id: this.patient_address.value.city_id }];
          }
        }
        this.addAddressModal.show();
      } else {
        this.zipClear('', 1);
        this.addAddressModal.show();
      }
    } else {
      this.confirmPaymentModal.show();
    }
  }
  CatchStripeTokenForNewCard(token_data, modal) {
    if (token_data.token && token_data.token.card && token_data.token.card.funding) {
      if (this.mainService.featureList && this.mainService.featureList.length) {
        const featureFilter = this.mainService.featureList.find(item => item.feature_enum === 'PAYMENTMETHOD');
        const getFeature = featureFilter ? JSON.parse(JSON.stringify(featureFilter)) : {};
        if (getFeature && getFeature.payment_method) {
          getFeature.payment_method = JSON.parse(getFeature.payment_method);
          // tslint:disable-next-line:max-line-length
          if (!getFeature.payment_method.includes((token_data.token.card.funding + '').toLocaleUpperCase())) {
            this.mainService.setLoader(false);
            this.toaster.message(`Payment type ${token_data.token.card.funding} is not supported as per your business plan`, 3);
            return false;
          }
        } else {
          this.mainService.setLoader(false);
          this.toaster.message(`Payment type is not supported as per your business plan.`, 3);
          return false;
        }
      }
    }
    if (token_data.token && token_data.token.card && token_data.token.card.brand) {
      const str = token_data.token.card.brand;
      const str2 = str.charAt(0).toUpperCase() + str.slice(1);
      token_data.token.card.brand = str2;
    }


    this.recurring_last4 = token_data.token.card.last4;
    this.recurring_token = token_data.token.id;
    const params = {
      contract_patient_token: this.contractToken,
      stripe_token: null,
      setup_id: token_data.token.id,
      payment_source_type: 3,
      contract_id: this.planInfo.contract_id,
      patient_mobile_country_code: this.patient_address.controls.patient_mobile_country_code.value
    };

    if (token_data.token && token_data.token.extra_data && token_data.token.extra_data.paymentIntentId) {
      params['payment_intent_id'] = token_data.token.extra_data.paymentIntentId;
    }

    if (token_data.token && token_data.token.extra_data && token_data.token.extra_data.cardType) {
      params['card_type'] = token_data.token.extra_data.cardType;
    }
    if (this.add_bank_step == 'bank') {
      params['bank_status'] = 'succeeded';
      this.confirmProposalApi(params);
    }
    this.mainService.setLoader(true);
    if (this.paymentLoader) {
      return false;
    } else {
      this.paymentLoader = true;
      this.proposal.api('post', 'add_payment_source', this.mainService.urlParams(params))
        .subscribe((data: any) => {
          if (data && typeof data == 'string') data = JSON.parse(data);
          this.paymentLoader = false;
          this.mainService.setLoader(false);
          if (data.is_error == 0) {
            this.backUpCard = false;
            this.addNewPaymentMethodModal.hide();
            if (!this.patientData['payment_sources']) {
              this.patientData['payment_sources'] = [];
            }
            // tslint:disable-next-line:max-line-length
            this.patientData['payment_sources'] = [...[{ source_id: data.source_id, brand: token_data.token.card.brand, last4: token_data.token.card.last4, fingerprint: data.fingerprint, card_type: data.card_type, payment_source_type: data.payment_source_type, payment_source: this.add_bank_step == 'card' ? 'card' : 'Bank' }], ...this.patientData['payment_sources']];
            if (Number(this.opened_step) === 1) {

              this.dp_source_id = data.source_id;
              this.primaryCardChanged(2, this.dp_source_id);
              if (this.actual_matrix) {
                this.planInfo.selected_payment_matrix = JSON.parse(JSON.stringify(this.actual_matrix));
              }
            } else if (Number(this.mainService.current_step) === 3 && Number(this.opened_step) === 2) {
              this.recurring_source_id = data.source_id;
              if (!this.dp_source_id && data.payment_source_type != 1) {
                this.dp_source_id = JSON.parse(JSON.stringify(data.source_id));
              }
            } else if (Number(this.mainService.current_step) === 3 && Number(this.opened_step) === 3) {
              this.backup_source_id = data.source_id;
            }
            if (window.screen.width < 768) {
              // if (this.payment_step == 1) {
              //   this.opened_step = 2;
              //   this.payment_step = 2;
              // } else if (this.payment_step == 2) {
              //   this.opened_step = 3;
              //   this.payment_step = 3;
              // }
              this.closeBank();
              this.setNavigationData();
            }
            setTimeout(() => {
              this.showElement = false;
              this.checkPaymentSources();
              this.selected_card = data;
              this.saveCard();
            }, 200);
          }
          if (data.is_error == 1) {
            this.showElement = false;
            this.callIntentApi();
            if (data.override_text || data.err) {
              this.toaster.message(data.override_text || data.err, 3);
            }
          }
        }, (error: any) => {
          this.paymentLoader = false;
          this.mainService.setLoader(false);
        });
    }
  }
  primaryCardChanged(payment_source_type, source_id) {
    if (source_id !== -1 && payment_source_type == 1 && this.planInfo.enrollment_waiver == 1 && this.planInfo.selected_payment_matrix.primary_type == 3 && this.planInfo.enrollment_enabled == 0) {
      this.is_waived = 1;
    } else {
      this.is_waived = 0;
    }
    this.calculateTotalPayable();
  }
  // openAddCardBankPopup() {
  //   this.plaidService.openPlaidPopup(
  //     {
  //       token: this.contractToken,
  //       type: 3,
  //       plan_index: this.selectedPlanIndex,
  //       patient_id: this.patientData['patient_id']
  //     }
  //   )
  // }
  // tslint:disable-next-line:member-ordering
  showElement = false;
  openAddCardBankPopup(modal, payment_source_type) {
    this.payment_source_type = payment_source_type;
    if (this.selected_card) {
      if (this.opened_step == 1) {
        this.dp_source_id = this.selected_card['source_id'];
      } else if (this.opened_step == 2) {
        this.recurring_source_id = this.selected_card['source_id'];
        if (!this.dp_source_id && this.selected_card['payment_source_type'] != 1) {
          this.dp_source_id = this.selected_card['source_id'];
        }
        if (this.recurring_source_id == this.backup_source_id) {
          this.backup_source_id = null;
        }
        this.selected_recurring_card = this.selected_card;
      } else if (this.opened_step == 3) {
        this.backup_source_id = this.selected_card['source_id'];
      }
      this.addNewPaymentMethodModal.hide();
      this.checkPaymentSources();
    } else {
      this.callIntentApi();
    }

    // this.plaidService.openPlaidPopup(
    //   {
    //     token: this.contractToken,
    //     type: 6,
    //     patient_id: this.patientData['patient_id']
    //   }
    // )
  }

  callIntentApi(checkValidation = true, addRecurringBtn = false) {
    if (this.bank_addded && this.add_bank_step == 'bank') {
      this.mainService.setLoader(false);
      if (checkValidation) {
        this.mainService.customPopups('Please select the bank or change payment method', 1);
      }
      return;
    }
    const params = {
      contract_patient_token: this.contractToken,
      payment_matrix_type: this.opened_step == 1 ? this.mainService.payment_method_type_selected.PRIMARY : (this.opened_step == 2 ? this.mainService.payment_method_type_selected.RECURRING : this.mainService.payment_method_type_selected.BACKUP),
      payment_source_type: (this.add_bank_step + '').toUpperCase() == 'BANK' ? 1 : 2
    };
    this.mainService.setLoader(true);
    this.proposal.api('post', 'create_payment_intent', this.mainService.urlParams(params)).subscribe(response => {
      if (response.is_error == 0 && response.client_secret) {
        if (response.payment_method_type && response.payment_method_type.length && response.payment_method_type.includes('acss_debit') && !addRecurringBtn) {
          this.mainService.stripe.confirmAcssDebitSetup(
            response.client_secret,
            {
              payment_method: {
                billing_details: {
                  name: response.patient_name,
                  email: response.email,
                },
              },
            }
          ).then(resp => {
            this.mainService.setLoader(false);
            if (resp.setupIntent) {
              const obj = {
                contract_patient_token: this.contractToken,
                setup_id: resp.setupIntent.id,
                payment_source_type: 1,
                contract_id: this.planInfo.contract_id
              };
              this.confirmProposalApi(obj);
            } else {
              this.mainService.customPopups('Please try again later', 1);
            }
          }).catch(err => {
            this.mainService.setLoader(false);
          });
        } else {
          this.showElement = true;
          this.validValue = false;
          // this.addNewPaymentMethodModal.hide();
          this.mainService.setLoader(false);
          response['patient_address'] = this.patient_address.value.address;
          response['patient_city'] = this.patient_address.controls.city.value;
          response['patient_state_code'] = this.patient_address.controls.state_code.value;
          response['patient_zip'] = this.patient_address.controls.zip.value;
          if (this.patientData && this.patientData.country_id == 7 && (this.patientData.patient_mobile_country_code == '+1')) {
            this.mainService.currency_data.country_code = 'US';
            response['country_code'] = this.mainService.currency_data.country_code;
          } else {
            response['country_code'] = this.mainService.currency_data.country_code;
          }
          this.mainService.createStripeElmentsDynamic(response.client_secret, 0, response);
          // modal.show();
          if (this.mainService.stripeElement2PaymentIntent) {
            setTimeout(() => {
              if (params.payment_source_type != 1) {
                this.mainService.stripeAddressElement.mount('#address-element');
                this.mainService.stripeElement2PaymentIntent.mount('#payment-element');
              } else {
                this.mainService.stripeElement2PaymentIntent.mount('#payment-element');
              }
            }, 1000);
          }
        }
      } else {
        this.mainService.setLoader(false);
        this.mainService.customPopups(response.err, 1);
      }
    });
  }

  confirmPayment() {
    this.mainService.setLoader(true);
    this.mainService.stripe.confirmSetup({
      elements: this.mainService.stripePaymentIntent,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: environment.request_panel_link + 'payment-details/' + this.contractToken
      },
      redirect: "if_required"
    }).then(resp => {
      if (resp.setupIntent && resp.setupIntent.payment_method) {
        const obj = {
          contract_patient_token: this.contractToken,
          // patient_id: this.patientData['patient_id'],
          setup_id: resp.setupIntent.id,
          payment_source_type: this.add_bank_step == 'bank' ? 1 : 2, // for bank and card
          contract_id: this.planInfo.contract_id
        };
        if (this.add_bank_step == 'bank') {
          obj['bank_status'] = 'succeeded';
          this.confirmProposalApi(obj);
        }
      } else {
        this.mainService.setLoader(false);
      }
    })
      .catch(err => {
        this.mainService.saveFinancingError({ payment_intent_id: "dummyIntent", contract_token: this.contractToken, error_message: err['message'], error_type: "payPaymentv2" });

      });
  }

  confirmProposalApi(obj) {
    this.proposal.api('post', 'add_payment_source', this.mainService.urlParams(obj)).subscribe(response => {
      this.mainService.setLoader(false);
      if (response.is_error) {
        this.mainService.customPopups(response.err || response.override_text, 1);
        this.showElement = false;
        this.callIntentApi();
        // this.addBankModal.hide();
        // this.openModal_1(this.opened_step, this.addNewPaymentMethodModal);
      } else {
        this.backUpCard = false;
        if (response && typeof response == 'string') {
          response = JSON.parse(response);
        }
        if (this.add_bank_step == 'bank' && obj.payment_source_type == 1) {
          this.bank_addded = true;
        }
        if (this.opened_step == 1) {
          this.dp_source_id = response.source_id;
          this.primaryCardChanged(2, this.dp_source_id);
          if (this.actual_matrix) {
            this.planInfo.selected_payment_matrix = JSON.parse(JSON.stringify(this.actual_matrix));
          }
        } else if (this.opened_step == 2) {
          this.recurring_source_id = response.source_id;
          if (!this.dp_source_id && response.payment_source_type != 1) {
            this.dp_source_id = response.source_id;
          }
        } else if (this.opened_step == 3) {
          this.backup_source_id = response.source_id;
        }
        this.patientData['payment_sources'] = [...[{ source_id: response.source_id, brand: response.brand, last4: response.last4, fingerprint: response.fingerprint, payment_source_type: response.payment_source_type, opened_step: this.opened_step, payment_source: this.add_bank_step == 'card' ? '' : 'Bank' }], ...this.patientData['payment_sources']];
        const matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.recurring_source_id);
        if (matched_source && matched_source[0]) {
          this.selected_recurring_card = matched_source[0];
        }
        this.new_bank_added = 1;
        this.setNavigationData();
        this.checkPaymentSources();
        // this.addBankModal.hide();
        this.addNewPaymentMethodModal.hide();
        this.showElement = false;
      }
    });
  }

  // reAuthenticatePlaid() {
  //   this.plaidService.openPlaidPopup(
  //     {
  //       token: this.contractToken,
  //       type: 3,
  //       plan_index: this.selectedPlanIndex,
  //       patient_id: this.patientData['patient_id'],
  //       plaid_access_token: this.patientData['plaid_access_token']
  //     }
  //   )
  // }
  ChangeArrows(step) {
    if (step == 1) {
      if (this.opened_step == 1) {
        this.opened_step = 0;
      } else {
        this.payment_step = 1;
        this.opened_step = 1;
      }
    } else if (step == 2) {
      if (this.opened_step == 2) {
        this.opened_step = 0;
      } else {
        this.payment_step = 1;
        this.nextStep();
      }
    } else if (step == 3) {
      if (this.opened_step == 3) {
        this.opened_step = 0;
      } else {
        this.payment_step = 2;
        this.nextStep();
      }
    }
  }
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (this.showConfirmationDialog) {
      $event.returnValue = 'Are you sure you want to leave this page?';
    }
  }
  detect(eve?) {
    if (eve) {
      this.showConfirmationDialog = true;
    }
  }

  checkAddCard(modal) {
    if (this.opened_step == 1) {
      if (this.add_card_source_id) {
        this.dp_source_id = this.add_card_source_id;
        modal.hide();
        this.ChangeArrows(2);
      } else {
        this.GetStripeToken('add_new_card1');
      }
    } else if (this.opened_step == 2) {
      if (this.add_card_source_id) {
        this.recurring_source_id = this.add_card_source_id;
        modal.hide();
        this.ChangeArrows(3);
      } else {
        this.GetStripeToken('add_new_card1');
      }
    } else if (this.opened_step == 3) {
      if (this.add_card_source_id) {
        this.backup_source_id = this.add_card_source_id;
        this.nextStep(modal);
      } else {
        this.GetStripeToken('add_new_card1');
      }
    }
  }
  CardFocussed() {
    this.add_card_source_id = null;
    if (this.opened_step == 1) {
      this.dp_source_id = null;
    } else if (this.opened_step == 2) {
      this.recurring_source_id = null;
    } else if (this.opened_step == 3) {
      this.backup_source_id = null;
    }
  }
  BackAddCard(modal) {
    this.add_card_source_id = null;
    if (this.opened_step == 1) {
      this.dp_source_id = null;
    } else if (this.opened_step == 2) {
      this.recurring_source_id = null;
    } else if (this.opened_step == 3) {
      this.backup_source_id = null;
    }
    modal.hide();
  }

  goToLink(url: string) {
    if (!url.includes('http')) {
      url = "http://" + url
    }
    window.open(url, "_blank");
  }
  // initSignPad() {
  //   setTimeout(() => {
  //     if (this.signaturePad && !this.signature) {
  //       this.signaturePad.set('canvasWidth', this.canvasDiv.nativeElement.offsetWidth);
  //       this.signaturePad.set('canvasHeight', this.canvasDiv.nativeElement.offsetHeight);
  //       this.signaturePad.clear();
  //     }
  //   }, 200);
  // }

  resizesignature() {
    if (this.signaturePadOptions) {
      if (window.innerWidth >= 1200) {
        this.signaturePadOptions['canvasWidth'] = '600';
        this.signaturePadOptions['canvasHeight'] = '250';
      }
      else if (window.innerWidth >= 768) {
        this.signaturePadOptions['canvasWidth'] = '400';
        this.signaturePadOptions['canvasHeight'] = '200';
      }
      else if (window.innerWidth <= 767) {
        this.signaturePadOptions['canvasWidth'] = window.innerWidth - 30;
        this.signaturePadOptions['canvasHeight'] = '200';
      }
    }

  }

  // initSignPad() {
  //   // setTimeout(() => {
  //   console.log(this.signaturePad)
  //   if (this.signaturePad && !this.signature) {
  //     console.log(this.signaturePad);
  //     this.signaturePad.set('canvasWidth', this.canvasDiv.nativeElement.offsetWidth);
  //     this.signaturePad.set('canvasHeight', this.canvasDiv.nativeElement.offsetHeight);
  //     this.signaturePad.clear();
  //   }
  //   // }, 0);
  // }


  clearSign() {
    // this.signaturePad.clear();
    this.signaturePadComponent.clear();

    this.mainService.signature = '';
    localStorage.removeItem('userSign');
  }
  drawComplete(dataUrl: string) {
    if (!dataUrl) {
      this.signatureUrl = '';
      this.signature = '';
      this.mainService.signature = '';
      return;
    }
    // will be notified of szimek/signature_pad's onEnd event
    // //console.log(this.signaturePad.toDataURL());
    this.signatureUrl = dataUrl;
    const dataURI = this.signatureUrl;
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {
      type: 'image/jpeg'
    });
    this.signature = blob;
    // this.toasterService.pop('success', 'Signature registered successfully', '');
  }

  getMyCard(source_id?, source?) {
    let card;
    if (this.patientData && this.patientData[source]) {
      this.patientData[source].forEach((item) => {
        if (Number(item.source_id) === Number(source_id)) {
          item.brand = item.brand.toLowerCase();
          card = item;
        }
        return card;
      });
    }
    return card;
  }



  saveCard() {
    if (this.selected_card) {
      if (this.selected_card.funding) {
        if (this.mainService.featureList && this.mainService.featureList.length) {
          const featureFilter = this.mainService.featureList.find(item => item.feature_enum === 'PAYMENTMETHOD');
          const getFeature = featureFilter ? JSON.parse(JSON.stringify(featureFilter)) : {};
          if (getFeature && getFeature.payment_method) {
            getFeature.payment_method = JSON.parse(getFeature.payment_method);
            // tslint:disable-next-line:max-line-length
            if ((this.selected_card.payment_source + '').toLocaleUpperCase() != 'BANK' && !getFeature.payment_method.includes((this.selected_card.funding + '').toLocaleUpperCase())) {
              this.mainService.setLoader(false);
              this.toaster.message(`Payment type ${this.selected_card.funding} is not supported as per your business plan`, 3);
              return false;
            }
          } else {
            // tslint:disable-next-line:max-line-length
            if ((this.selected_card.payment_source + '').toLocaleUpperCase() === 'BANK' && !getFeature.payment_method.includes(('ACH').toLocaleUpperCase())) {
              this.mainService.setLoader(false);
              this.toaster.message(`Payment type BANK is not supported as per your business plan`, 3);
              return false;
            } else {
              return true;
            }
          }
        }
      }
      if (Number(this.opened_step) === 2) {
        this.recurring_source_id = this.selected_card.source_id;
        this.selected_recurring_card = this.selected_card;
        // tslint:disable-next-line:max-line-length
        if (this.selected_backup_card && this.selected_backup_card.fingerprint && this.selected_backup_card.fingerprint == this.selected_card.fingerprint) {
          this.selected_backup_card = {};
          this.backup_source_id = 0;
        }

      } else if (Number(this.opened_step) === 3) {
        this.backup_source_id = this.selected_card.source_id;
        this.selected_backup_card = this.selected_card;

      } else if (Number(this.opened_step) === 1) {
        this.dp_source_id = this.selected_card.source_id;
        this.selected_dp_card = this.selected_card;
        // if(this.selected_backup_card && this.selected_backup_card.fingerprint && this.selected_backup_card.fingerprint == this.selected_card.fingerprint) {
        //   this.selected_backup_card = {};
        //   this.backup_source_id = 0
        // }
      }
      if ([1].includes(this.opened_step)) {
        this.primaryCardChanged(this.selected_card.payment_source_type, this.selected_card.source_id);
        // this.calculateTotalPayable();
      }
      this.selected_card = null;
      this.checkPaymentSources();
      this.setNavigationData();
      this.addNewPaymentMethodModal.hide();
    }
  }


  switchForm() {
    this.mainService.setLoader(true); //generate signature
    this.resizesignature()

    if (this.mainService.current_step === 3) {
      if (!this.recurring_source_id) {
        this.mainService.setLoader(false);
        this.toaster.message('Please select/add payment source.', 3);
        return;
      }

      if (this.planInfo.selected_payment_matrix.backup_required === 1 && !this.backup_source_id) {
        this.mainService.setLoader(false);
        this.toaster.message('Please add/select a payment method for the backup payment', 3);
        return;
      }
      // if (!this.paymentDetails.recurringDate) {
      //   this.toaster.message('Please choose a valid recurring payment source.', 2);
      //   return;
      // }
      // tslint:disable-next-line:max-line-length
      if (this.recurring_source_id && this.backup_source_id && this.getMyCard(this.recurring_source_id, 'recurring_sources').fingerprint === this.getMyCard(this.backup_source_id, 'backup_sources').fingerprint) {
        this.mainService.setLoader(false);
        this.toaster.message('Recurring payment method and backup payment method cannot be same', 3);
        return false;
      }
      this.mainService.current_step = 4;
    }
  }
  openModal_1(step, modal) {
    console.log(step);
    // this.validValue = false;
    this.opened_step = Number(step);
    // if (this.opened_step == 2 && this.planInfo.selected_payment_matrix.recurring_type == 1) {
    //   this.add_bank_step = 'bank';
    // } else if (this.opened_step == 3 && this.planInfo.selected_payment_matrix.backup_type == 1) {
    //   this.add_bank_step = 'bank';
    // } else if (this.opened_step == 1 && this.planInfo.selected_payment_matrix.primary_type == 1) {
    //   this.add_bank_step = 'bank';
    // } else {
    //   this.gettingCard ? this.add_bank_step = 'card' : this.add_bank_step = 'bank';
    // }
    if (this.opened_step == 2 && (this.planInfo.selected_payment_matrix.recurring_type == 1 || this.planInfo.selected_payment_matrix.recurring_type == 3)) {
      this.add_bank_step = 'bank';
    } else if (this.opened_step == 3 && (this.planInfo.selected_payment_matrix.backup_type == 1 || this.planInfo.selected_payment_matrix.recurring_type == 3) && !(this.getMyCard(this.recurring_source_id, 'recurring_sources') && this.getMyCard(this.recurring_source_id, 'recurring_sources').payment_source == 'Bank')) {
      this.add_bank_step = 'bank';
    } else if (this.opened_step == 1 && (this.planInfo.selected_payment_matrix.primary_type == 1 || this.planInfo.selected_payment_matrix.recurring_type == 3)) {
      this.add_bank_step = 'card';
    } else {
      this.add_bank_step = 'card';
    }
    console.log(this.add_bank_step);
    // this.validValue = false;
    if (this.opened_step == 3) {
      this.patientData_backup = this.patientData && this.patientData['backup_sources'] && this.patientData['backup_sources'].filter(source => source.card_type);
      this.patientData_backup = this.patientData_backup && this.patientData_backup.filter(source => source.card_type.includes("BACKUP_CARD") || source.card_type.includes("TODAY_PAYMENT_CARD"));
      if (this.add_bank_step == 'bank' && !this.bank_addded) {
        this.callIntentApi();
        this.validValue = true;
      }
      if (this.add_bank_step == 'bank' && this.bank_addded) {
        this.validValue = true;
      }
      // if (this.add_bank_step == 'card' 
      //     && (this.patientData && this.patientData.recurring_sources && this.patientData.recurring_sources.length > 0 
      //     && this.patientData && this.patientData.backup_sources && this.patientData.backup_sources.length > 0
      //     && this.patientData && this.patientData.primary_sources && this.patientData.primary_sources.length > 0 )) {
      //   this.validValue = true;
      // }
      // if (this.gettingCard) {
      //   if (this.patientData_recure && this.patientData_recure.length > 0) {
      //     this.validValue = true;
      //   } else {
      //     this.callIntentApi();
      //   }
      // }
      this.backUpCard = true;
    } else {
      this.backUpCard = false;
    }

    if (this.opened_step == 1) {
      if (this.add_bank_step == 'bank' && !this.bank_addded) {
        this.callIntentApi();
        this.validValue = true;
      }
      if (this.add_bank_step == 'bank' && this.bank_addded) {
        this.validValue = true;
      }
      if (this.add_bank_step == 'card') {
        this.validValue = true;
      }
      this.todayPaymentCard = true;
    } else {
      this.todayPaymentCard = false;
    }

    if (this.opened_step == 2) {
      this.patientData_recure = this.patientData && this.patientData['recurring_sources'] && this.patientData['recurring_sources'].filter(source => source && source.card_type);
      this.patientData_recure = this.patientData_recure && this.patientData_recure.filter(source => source.card_type.includes("RECURRING_CARD"));
      console.log(this.patientData_recure);
      if (this.add_bank_step == 'bank' && !this.bank_addded) {
        const automation_business = this.patientData && this.patientData.total_automation_business
        if (!automation_business.includes(String(this.contract_service_record && this.contract_service_record[0].doctor_id))) {
          this.callIntentApi(true, true);
        }
        this.validValue = true;
      }
      if (this.add_bank_step == 'bank' && this.bank_addded) {
        this.validValue = true;
      }
      this.recurringCard = true;
    } else {
      this.recurringCard = false;
    }
    this.selected_card = '';
    setTimeout(() => {
      this.dataEnter = true;
    }, 200);

    if (modal) {
      this.opened_modal = modal;
      modal.show();
      setTimeout(() => {
        // this.callIntentApi();
        this.selected_card = '';
      }, 500);
      this.setNavigationData();
    }
  }
  existing(data) {
    // if (this.selectTypeButtonCardBank == data) {
    //   return;
    // }
    // this.selectTypeButtonCardBank = data;
    if (data == this.buttonSelectedType.existing) {
      // this.opened_step = 2;
      this.validValue = true;
      this.showElement = false;
      this.selected_card = '';
    }
    if (data == this.buttonSelectedType.bank) {
      this.selected_card = '';
      if (this.add_bank_step == 'bank') {
        if (this.bank_addded) {
          return this.validValue = true;
        }
        this.callIntentApi();
        this.validValue = true;
      } else {
        this.callIntentApi();
        this.validValue = false;
      }
    }
    if (data == this.buttonSelectedType.cardTab) {
      if ((this.patientData && this.patientData.recurring_sources && this.patientData.recurring_sources.length == 0
        && this.patientData && this.patientData.backup_sources && this.patientData.backup_sources.length == 0
        && this.patientData && this.patientData.primary_sources && this.patientData.primary_sources.length == 0)) {
        this.callIntentApi();
        // this.validValue = false;
      }
      this.validValue = false;
    }
    // if (this.add_bank_step == 'card' &&
    //  (this.patientData && this.patientData.recurring_sources && this.patientData.recurring_sources.length > 0
    //       && this.patientData && this.patientData.backup_sources && this.patientData.backup_sources.length > 0
    //       && this.patientData && this.patientData.primary_sources && this.patientData.primary_sources.length > 0)) {
    //   this.callIntentApi();
    this.validValue = true;
    //   this.validValue = false;
    // }
    console.log(data);
  }


  changeScreen() {
    if (this.mainService.current_step === 2) {
      this.backToPayment();
      return;
    }
    this.mainService.current_step = this.mainService.current_step - 1;
    if ((this.split_request_data && this.split_request_data[0]?.ar_flow_immediate) && this.mainService.current_step == 3) {
      this.mainService.current_step = this.mainService.current_step - 1;
    }
  }
  backToPayment() {
    this.mainService.current_step = 2;
    this.router.navigate([`/plans/${this.contractToken}`]);
  }

  canGoBack() {
    // if (window['navigation'] && window['navigation'].canGoBack) {
    //   return window['navigation'].canGoBack;
    // } else {
    //   return false;
    // }
    return window.history.length > 1;
  }



  getZipselected(zipObj) {
    try {
      if (zipObj && (!zipObj.zip || (zipObj.zip.length < 4))) {
        zipObj.zip = 'NULL'
      }
      if (zipObj) {
        if (!zipObj?.['country_code']) {
          zipObj['country_code'] = this.mainService.defaultCountry['country_code'];
        }
        if (!zipObj['latitude'] && !zipObj['longitude']) {
          zipObj['latitude'] = zipObj['longitude'] = 0;
        }
        if (zipObj.zip && zipObj.city) {
          this.zipPostalCode = zipObj.zip;
          this.zipCode = zipObj;
          this.mainService.zipCode = zipObj;
          if (this.zipCode && this.zipCode.zip == 'NULL') {
            zipObj.zip = '';
            this.patient_address.controls.city_id.clearValidators();
          } else {
            this.patient_address.controls.city_id.clearValidators();
          }
          this.patient_address.controls.city_id.setValue(zipObj.city_id);
          this.patient_address.controls.city.setValue(zipObj.city);
          this.patient_address.controls.state_name.setValue(zipObj.state_name);
          this.patient_address.controls.state_code.setValue(zipObj.state_code);
          this.patient_address.controls.zip.setValue(zipObj.zip);
          this.patient_address.controls.address.patchValue( zipObj && (zipObj.formatted_address ||  (zipObj.item && zipObj.item.name)));
          this.patient_address.controls.zipSelected.setValue(true);
          this.patient_address.updateValueAndValidity();
        } else if(zipObj.formatted_address) {
          this.zipPostalCode = zipObj.formatted_address;
          this.zipCode = zipObj;
          this.mainService.zipCode = zipObj;
          this.patient_address.controls.city_id.clearValidators();
          this.patient_address.controls.city_id.updateValueAndValidity();
          this.patient_address?.get('address').setValue(this.zipPostalCode);
        }
      } else {
        this.zipPostalCode = '';
        this.zipCode = {
          zip: '',
          state: '',
          city: '',
          city_id: '',
          formatted_address: '',
        };
        this.patient_address.controls.city_id.setValue('');
        this.patient_address.controls.city.setValue('');
        this.patient_address.controls.state_name.setValue('');
        this.patient_address.controls.state_code.setValue('');
        this.patient_address.controls.zip.setValue('');
        this.patient_address.controls.address.setValue('');
        this.patient_address.controls.zipSelected.setValue(true);
        this.patient_address.updateValueAndValidity();
      }
    } catch (err) {
      console.log(err);
    }
  }

  calculateTotalPayableAmount(amt1, amt2) {
    return Number(amt1) + Number(amt2);
  }

  saveOptions(card?) {
    // if (!this.stripeFieldsshow && card == 'add_new_card' && (!this.selected_card && this.opened_step != 3 && this.patientData.primary_sources.length > 0) ) {
    //   this.mainService.customPopups('Please select a valid payment source', 1);
    //   return;
    // }
    // if (!this.stripeFieldsshow && card == 'add_new_card' && (!this.selected_card && this.opened_step == 3 && this.patientData.backup_sources.length > 0) ) {
    //   this.mainService.customPopups('Please select a valid payment source', 1);
    //   return;
    // }
    // if (this.add_bank_step == 'bank' && !this.selected_card) {
    //   this.mainService.customPopups('Please select a valid payment source.', 1);
    //   return;
    // }
    if (this.recurring_source_id && this.backup_source_id && this.getMyCard(this.recurring_source_id, 'recurring_sources').fingerprint === this.getMyCard(this.backup_source_id, 'backup_sources').fingerprint) {
      this.toaster.message('Recurring payment method and backup payment method cannot be same', 3);
      return;
    }

    // tslint:disable-next-line:max-line-length
    if (!this.selected_card && (this.opened_step === 1) || !this.selected_card && this.opened_step === 2 || !this.selected_card && this.opened_step === 3) {
      this.GetStripeToken(card);
      return;
    }
    this.saveCard();
  }

  changePaymentMethodFailed(modal?) {
    if (this.payment_error.includes('recurring')) {
      this.opened_step = 2;
    }
    if (this.payment_error.includes('insufficient funds')) {
      this.opened_step = 1;
    }
    if (!this.payment_error.includes('recurring')) {
      this.opened_step = 1;
    }
    if (this.payment_error) {
      this.opened_step = 1;
    }

    modal.hide();
    setTimeout(() => {
      this.openModal_1(this.opened_step, this.addNewPaymentMethodModal);
      this.addNewPaymentMethodModal.show();
    }, 500);
  }

  onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    const hoverWrapper = (hoverEvent) => {
      const { cell, isHovered } = hoverEvent;

      if ((isHovered &&
        !!navigator.platform &&
        /iPad|iPhone|iPod/.test(navigator.platform)) &&
        'ontouchstart' in window
      ) {
        (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
      }

      return dayHoverHandler(hoverEvent);
    };
    event.dayHoverHandler = hoverWrapper;
  }
  toggle() {
    this.add_button = !this.add_button;
  }
  dateChanged(date?) {
    let tilaData;
    tilaData = JSON.parse(localStorage.getItem('iframe_tila_data'));
    tilaData = { ...tilaData, start_date: new Date(date).toLocaleDateString() };
    localStorage.setItem('iframe_tila_data', JSON.stringify(tilaData));
  }

  getNumber(d) {
    return Number(d);
  }

  changeFlag(i) {
    this.flag_code = (this.mainService.country_data[i]['country_code'] + '').toLocaleLowerCase();
  }

  showStripefields() {
    this.add_bank_step = 'card';
    this.selected_card = '';
    this.stripeFieldsshow = true;
    this.valueNotValid = true;
    if (this.stripeFieldsshow == true) {

      this.AddStripeElement('add_new_card');
    }
  }
  checkValue(e: any, value) {
    this.stripeFieldsshow = false;
    if (value == 1) {
      this.valueNotValid = true;
    }
  }
  closeBank() {
    this.addNewPaymentMethodModal.hide();
    setTimeout(() => {
      this.validValue = false;
      this.dataEnter = false;
      this.showElement = false;
      this.stripeFieldsshow = false;
    }, 800);
  }

  // checkSSn() {
  //   const invalid_ssn = ['002281852', '042103580', '062360749', '078051120', '095073645', '128036045', '135016629', '141186941', '165167999', '165187999', '165207999', '212099999', '165227999', '306302348', '165247999', '189092294', '308125070', '212097694', '549241889', '468288779'];
  //   if (this.mainService.currency_data.country_code == 'US' || this.mainService.currency_data.country_code == 'CA') {
  //     if (!this.mainService.validateSSN(this.patient_address && this.patient_address.value && this.patient_address.value.patient_ssn ? this.patient_address.value.patient_ssn : this.patientData['patient_ssn'])) {
  //       this.errorMsg = 'Please enter a valid ' + this.mainService.document_label;
  //       this.patient_address.get("patient_ssn").setErrors({ error: "Please enter valid" + `${this.mainService.document_label}` })

  //       this.showvalidation = true;
  //       // this.toaster.message('warning', 'Please enter valid SSN', '');
  //       return;
  //     }
  //   } else {
  //     if (this.showSSNfields && !this.mainService.validateCountry(this.patient_address.controls.patient_ssn.value)) {
  //       // this.toaster.message('warning', 'Please enter a valid ' + this.mainService.document_label, '');
  //       this.errorMsg = 'Please enter a valid ' + this.mainService.document_label;
  //       this.patient_address.get("patient_ssn").setErrors({ error: "Please enter valid" + `${this.mainService.document_label}` })

  //       this.showvalidation = true;
  //       return;
  //     }
  //   }
  //   this.errorMsg = '';
  //   this.showvalidation = false;
  // }

  alphabet(name) {
    let inputValue = name && name.target && name.target.value;
    const allowedChars = inputValue.replace(/[^a-zA-Z0-9]/g, ''); // Clean the input value by removing special characters

    if (this.mainService.document_label === "NINO/CRN") {
      // if (inputValue && inputValue.length == 8) {
      let ssnRegex = new RegExp(this.validation_rules["TAX-ID"].regex);
      // var crnPattern = /^(?:[A-Z]{2}\d{6}|OC\d{4}[A-Z\d]{1,2}|SC\d{6}|NI\d{6})$/;
      var crnPattern = ssnRegex;
      if (!crnPattern.test(inputValue)) {
        this.patient_address.get("patient_ssn").setErrors({ err: "Please enter valid" + `${this.mainService.document_label}` })
        // this.showvalidation = true;
        return;
      }
      // this.showvalidation = false;
      // }
      // if (inputValue && inputValue.length == 9) {
      //   // var crnPattern = /^[A-CEGHJ-PR-TW-Z]{2}\d{6}[ABCDHMNPRTWXYZ]$/;
      //   var crnPattern = /^[A-Z]{2}\d{6}[A-Z]$/
      //   console.log(crnPattern.test(inputValue));
      //   if (!crnPattern.test(inputValue)) {
      //     this.patient_address.get("patient_ssn").setErrors({ err: "Please enter valid" + `${this.mainService.document_label}` })
      //     // this.showvalidation = true;
      //     return;
      //   }
      //   // this.showvalidation = false;
      // }
    }
    if ((this.mainService.document_label != "NINO/CRN") && (this.mainService.document_label != "Fiscal Code/Codice Fiscale") && this.mainService.document_label != 'Tax Identification Number (NIF)') {
      const inputValue = (event.target as HTMLInputElement).value;
      const numericRegex = /^[0-9]*$/;

      if (inputValue && !numericRegex.test(inputValue)) {
        (event.target as HTMLInputElement).value = inputValue.replace(/[^0-9]/g, '');
        return
      }
    }
    if (inputValue !== allowedChars) {
      this.patient_address.get("patient_ssn").setErrors({ err: "Please enter valid" + `${this.mainService.document_label}` })
      console.log("Invalid input: Special characters detected.");
      return
    }

    // this.showvalidation = false;
  }

  getParentDivWidth() {
    return document.getElementById('canvasDiv').offsetWidth;
  }

  australiaChange(val) {
    this.mainService.country_data$.subscribe(data => {
      if (data && data.length) {
        this.mobile_validation = data.filter(item => val == item.mobile_code)
        this.updateMasking(this.mobile_validation && this.mobile_validation[0] && this.mobile_validation[0].country_phone_format);
      }
    })
  }

  getStates() {
    return new Promise((res, rej) => {
      const body = {
        country_id: this.split_request_data[0].country_id
      }
  
      this.mainService.newApi('post', environment.request_url + 'get_states', body).subscribe(country_states => {
        if (!country_states.is_error) {
          this.country_states = country_states.states;
          this.showDropDown = [1, 2].includes(+this.split_request_data[0].country_id);
          res(true);
        } else {
          this.mainService.customPopups(country_states.err || country_states.override_text, 1);
          rej();
        }
      });
    });

  }

  stateSelected(st_code: string) {
    const state_name = this.country_states.find(state => state.state_code == st_code)['state_name'];
    this.patient_address.get('state_name').setValue(state_name);
    this.editAddressManually = true;
  }

}
